/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
export type StandardError = globalThis.Error;
export type Error500s =
  | 501
  | 502
  | 503
  | 504
  | 505
  | 506
  | 507
  | 508
  | 510
  | 511;
export type ErrorStatuses = 0 | Error500s;
export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

export type FetchResponseOfError = {
  data: null;
  error: StandardError;
  status: ErrorStatuses;
  args: FetchArgs;
};

export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = {
  data: TData;
  error: null;
  status: TStatus;
  args: FetchArgs;
  responseHeaders: Headers;
};

export type FetchResponse<
  TData,
  TStatus extends number = 0,
> = TStatus extends ErrorStatuses
  ? FetchResponseOfError
  : FetchResponseOfSuccess<TData, TStatus>;

export type TerminateRequest = null;
export type TerminateResponse = null;

export type Configuration = {
  apiUrl: string | (() => string);
  jwtKey: string | undefined | (() => string | null | undefined);
  requestMiddlewares?: Array<{
    name: string;
    fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
  }>;
  responseMiddlewares?: Array<{
    name: string;
    fn: <TData, TStatus extends number>(
      response: FetchResponse<TData, TStatus>,
    ) => FetchResponse<TData, TStatus> | TerminateResponse;
  }>;
};

let CONFIG: Configuration = {
  apiUrl: () => "",
  jwtKey: undefined,
  requestMiddlewares: [],
  responseMiddlewares: [],
};

export function setupClient(configuration: Configuration) {
  const uniqMiddlewares = <
    T extends
      | Configuration["requestMiddlewares"]
      | Configuration["responseMiddlewares"],
  >(
    oldMiddlewares: T,
    newMiddlewares: T,
  ): T => {
    return [
      ...(oldMiddlewares?.filter(
        (middleware) =>
          !newMiddlewares?.some((m) => m.name === middleware.name),
      ) ?? []),
      ...(newMiddlewares ?? []),
    ] as T;
  };

  CONFIG = {
    ...CONFIG,
    ...configuration,
    requestMiddlewares: uniqMiddlewares(
      CONFIG.requestMiddlewares,
      configuration.requestMiddlewares,
    ),
    responseMiddlewares: uniqMiddlewares(
      CONFIG.responseMiddlewares,
      configuration.responseMiddlewares,
    ),
  };
}

export function getApiUrl() {
  if (typeof CONFIG.apiUrl === "function") {
    return CONFIG.apiUrl();
  }
  return CONFIG.apiUrl;
}

export type Termination = {
  termination: {
    name: string;
  };
};

export function processRequestWithMiddlewares(
  request: FetchArgs,
): FetchArgs | Termination {
  for (const middleware of CONFIG.requestMiddlewares || []) {
    try {
      const middlewareResponse = middleware.fn(request);
      if (middlewareResponse === null) {
        return { termination: { name: middleware.name } };
      }
      request = middlewareResponse;
    } catch (e) {
      console.error("Request middleware error", e);
    }
  }
  return request;
}

export function processResponseWithMiddlewares<TData, TStatus extends number>(
  response: FetchResponse<TData, TStatus>,
): FetchResponse<TData, TStatus | 0> {
  for (const middleware of CONFIG.responseMiddlewares || []) {
    try {
      const middlewareResponse = middleware.fn(response);
      if (middlewareResponse === null) {
        return {
          status: 0,
          args: response.args,
          data: null,
          error: new Error(
            `Response terminated by middleware: ${middleware.name}`,
          ),
        } satisfies FetchResponseOfError;
      }
      response = middlewareResponse;
    } catch (e) {
      console.error("Response middleware error", e);
    }
  }
  return response;
}

export type FetchArgsOptions = Omit<
  RequestInit,
  "method" | "redirect" | "body"
>;

export type FetchArgs = {
  url: string;
  options: RequestInit;
};

export type UriComponent = string | number | boolean;
export type ParamsObject = {
  [key: string]: UriComponent | UriComponent[] | undefined | null;
};

export async function fetchJson<TData>(
  args: FetchArgs,
): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
  const errorResponse = (
    error: StandardError,
    status: number,
    args: FetchArgs,
  ) => {
    const errorResponse = {
      status: status as ErrorStatuses,
      args,
      data: null,
      error,
    } satisfies FetchResponseOfError;

    return processResponseWithMiddlewares(errorResponse);
  };

  const errorStatus = (args: FetchArgs) => {
    const errorResponse = {
      status: 0,
      args,
      data: null,
      error: new Error("Network error"),
    } satisfies FetchResponseOfError;

    return processResponseWithMiddlewares(errorResponse);
  };

  try {
    const fetchRequest = processRequestWithMiddlewares(args);

    if ("termination" in fetchRequest) {
      const terminationResponse = {
        status: 0,
        args,
        data: null,
        error: new Error(
          `Request terminated by middleware: ${fetchRequest.termination.name}`,
        ),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(terminationResponse);
    }

    const fetchResponse: Response = await fetch(
      fetchRequest.url,
      fetchRequest.options,
    );
    const status = fetchResponse.status;
    try {
      const json = await fetchResponse.json();
      const response = {
        data: json,
        status: fetchResponse.status,
        args,
        error: null,
        responseHeaders: fetchResponse.headers,
      };
      return processResponseWithMiddlewares(response);
    } catch (error) {
      return errorResponse(error as StandardError, status, args);
    }
  } catch {
    return errorStatus(args);
  }
}

export function getJwtKey(): string | null | undefined {
  if (typeof CONFIG.jwtKey === "function") {
    return CONFIG.jwtKey();
  }

  if (typeof CONFIG.jwtKey === "string") {
    return localStorage.getItem(CONFIG.jwtKey);
  }

  return undefined;
}

function getApiRequestData<Type>(
  requestContract: Type | undefined,
  isFormData: boolean = false,
): FormData | Type | {} {
  if (!isFormData) {
    return requestContract !== undefined ? requestContract : {};
  }

  //multipart/form-data
  const formData = new FormData();

  if (requestContract) {
    Object.keys(requestContract).forEach((key) => {
      const value = requestContract[key as keyof Type];
      const isKeyArrayAndValueIterable =
        key.endsWith("[]") &&
        typeof (value as any)[Symbol.iterator] === "function";
      const values = isKeyArrayAndValueIterable
        ? Array.from(value as Iterable<any>)
        : [value];
      for (const val of values) {
        if (val === undefined) {
          continue;
        }
        if (val === null) {
          formData.append(key, "");
        } else if (val instanceof File) {
          formData.append(key, val);
        } else if (typeof val === "object" && val !== null) {
          formData.append(key, JSON.stringify(val));
        } else {
          formData.append(key, val);
        }
      }
    });
  }

  return formData;
}

function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = request instanceof FormData ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return {
    options: requestOptions,
    url: `${url}${maybeQueryString}`,
  } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
  const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map((val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
          .join("&");
      }
      // Handling non-array parameters
      return value !== undefined && value !== null
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        : "";
    })
    .filter((part) => part !== "")
    .join("&");

  return queryString.length > 0 ? `?${queryString}` : "";
}

export function apiPost<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("POST", request, options, url, paramsObject),
  );
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("GET", undefined, options, url, paramsObject),
  );
}

export function apiPut<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("PUT", request, options, url, paramsObject),
  );
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("DELETE", undefined, options, url, paramsObject),
  );
}

export function apiPatch<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("PATCH", request, options, url, paramsObject),
  );
}
// INFRASTRUCTURE END

export type FileResponse = {
  data: Blob;
  fileName?: string;
};

export type ApiProblemDetails = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export type ErrorDetail = {
  code: ErrorCode;
  message?: string | null;
};

export enum ErrorCode {
  Unspecified = "Unspecified",
  OutOfRange = "OutOfRange",
  NotFound = "NotFound",
  Invalid = "Invalid",
  Forbidden = "Forbidden",
  TooManyRequests = "TooManyRequests",
  Conflict = "Conflict",
  NullOrEmpty = "NullOrEmpty",
  Unauthorized = "Unauthorized",
  ExternalProviderNotAvailable = "ExternalProviderNotAvailable",
}

export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export type EntityListOfExternalVoiceListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ExternalVoiceListItemDto[];
};

export type ExternalVoiceListItemDto = {
  externalID: string;
  name: string;
  language?: LanguageCodes | null;
};

export enum LanguageCodes {
  Czech = "Czech",
  English = "English",
  Deutsch = "Deutsch",
  French = "French",
  Italian = "Italian",
  Spanish = "Spanish",
  Polish = "Polish",
  Dutch = "Dutch",
  Romanian = "Romanian",
  Hungarian = "Hungarian",
  Portuguese = "Portuguese",
  Swedish = "Swedish",
  Bulgarian = "Bulgarian",
  Danish = "Danish",
  Finnish = "Finnish",
  Slovak = "Slovak",
  Croatian = "Croatian",
  Lithuanian = "Lithuanian",
  Slovenian = "Slovenian",
  Latvian = "Latvian",
  Estonian = "Estonian",
  Greek = "Greek",
  Maltese = "Maltese",
  Irish = "Irish",
}

export type ApiProblemDetailsOfSearchExternalVoicesErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SearchExternalVoicesErrorStatus {
  UnsupportedVoiceLlm = "UnsupportedVoiceLlm",
}

export enum VoiceLlm {
  ElevenLabs_V3 = "ElevenLabs_V3",
  MicrosoftTts = "MicrosoftTts",
  ElevenLabs_V2 = "ElevenLabs_V2",
  AiVoice = "AiVoice",
}

export type EntityListOfUserListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserListItemDto[];
};

export type UserListItemDto = {
  userID: string;
  login: string;
  firstName: string;
  lastName: string;
  dateCreated: string;
};

export enum UserListSortColumn {
  Login = "Login",
  FirstName = "FirstName",
  LastName = "LastName",
}

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

export type UserDetailDto = {
  userID: string;
  login: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  lastSignInDate?: string | null;
  phone?: string | null;
  userIdentityProviders: IdentityProvider[];
  profilePicture?: string | null;
  status: UserStatus;
  language?: LanguageCodes | null;
  currency: CurrencyCodes;
};

export enum IdentityProvider {
  Application = "Application",
  Google = "Google",
  BankID = "BankID",
}

export enum UserStatus {
  Unknown = "Unknown",
  Active = "Active",
  WaitingForEmailConfirmation = "WaitingForEmailConfirmation",
  WaitingForSetPassword = "WaitingForSetPassword",
}

export enum CurrencyCodes {
  CZK = "CZK",
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
  PLN = "PLN",
  CHF = "CHF",
  SEK = "SEK",
  NOK = "NOK",
  DKK = "DKK",
  HUF = "HUF",
  RON = "RON",
}

export type UploadUserProfilePictureCommandResult = {
  profilePictureUrl: string;
};

export type ApiProblemDetailsOfUploadUserProfilePictureErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum UploadUserProfilePictureErrorStatus {
  UserNotFound = "UserNotFound",
  FileTooLarge = "FileTooLarge",
  InvalidFileType = "InvalidFileType",
}

export type UploadUserProfilePictureRequest = {
  file: File;
};

export type DeleteUserProfilePictureCommandResult = {};

export type ApiProblemDetailsOfDeleteUserProfilePictureErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum DeleteUserProfilePictureErrorStatus {
  UserNotFound = "UserNotFound",
}

export type UpdateUserSettingsRequest = {
  language?: LanguageCodes | null;
  currency?: CurrencyCodes | null;
};

export type EntityListOfUserNotificationDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserNotificationDto[];
};

export type UserNotificationDto = {
  userNotificationID: string;
  params?: string | null;
  type: NotificationType;
  priority: NotificationPriority;
  seenAt?: string | null;
  readAt?: string | null;
  dateCreated: string;
};

export enum NotificationType {
  Actor_JobApprovalRequired = "Actor_JobApprovalRequired",
  Actor_WithdrawalApproved = "Actor_WithdrawalApproved",
  Actor_WithdrawalRejected = "Actor_WithdrawalRejected",
  Actor_WithdrawalExpired = "Actor_WithdrawalExpired",
  SysAdmin_ActorWithdrawalRequested = "SysAdmin_ActorWithdrawalRequested",
  SysAdmin_PartnerRegistrationRequested = "SysAdmin_PartnerRegistrationRequested",
  SysAdmin_ActorRegistrationRequested = "SysAdmin_ActorRegistrationRequested",
  Partner_JobApprovedByActor = "Partner_JobApprovedByActor",
  Partner_JobRejectedByActor = "Partner_JobRejectedByActor",
}

export enum NotificationPriority {
  Low = "Low",
  Normal = "Normal",
  High = "High",
}

export type UnseenNotificationCountDto = {
  count: number;
};

export type ReportingKpisDto = {
  revenueThisMonth: number;
  activeProjectsCount: number;
  newPartnersThisMonth: number;
  jobsThisMonth: number;
  averageActorApprovalDays?: number | null;
};

export type ReportingFinanceDto = {
  revenueOverTime: MonthlyRevenueItem[];
};

export type MonthlyRevenueItem = {
  year: number;
  month: number;
  amount: number;
};

export type ReportingProjectsDto = {
  statusDistribution: ProjectStatusCountItem[];
  averageCompletionDays?: number | null;
  averageJobCost?: number | null;
};

export type ProjectStatusCountItem = {
  status: ProjectState;
  count: number;
};

export enum ProjectState {
  InProgress = "InProgress",
  Draft = "Draft",
  Done = "Done",
  Closed = "Closed",
}

export type ReportingActorsDto = {
  topActorsByJobs: ActorJobCountItem[];
  topActorsByEarnings: ActorEarningsItem[];
};

export type ActorJobCountItem = {
  actorName: string;
  jobCount: number;
};

export type ActorEarningsItem = {
  actorName: string;
  totalEarnings: number;
};

export enum ReportingPeriod {
  ThisMonth = "ThisMonth",
  Last30Days = "Last30Days",
  ThisYear = "ThisYear",
  LastYear = "LastYear",
}

export type ReportingPartnersDto = {
  topPartnersByProjects: PartnerMetricItem[];
  topPartnersByJobs: PartnerMetricItem[];
  topPartnersBySpend: PartnerMetricItem[];
};

export type PartnerMetricItem = {
  partnerName: string;
  value: number;
};

export type ReportingGenerationsDto = {
  avgGenerationsPerJobByModel: MonthlyGenerationItem[];
  voiceModelUsageThisMonth: VoiceModelUsageItem[];
  jobStatusDistribution: JobStatusCountItem[];
};

export type MonthlyGenerationItem = {
  year: number;
  month: number;
  voiceLlm: VoiceLlm;
  avgCount: number;
};

export type VoiceModelUsageItem = {
  voiceLlm: VoiceLlm;
  count: number;
};

export type JobStatusCountItem = {
  status: JobStatus;
  count: number;
};

export enum JobStatus {
  InProgress = "InProgress",
  Done = "Done",
  WaitingForApproval = "WaitingForApproval",
  RejectedByActor = "RejectedByActor",
  AwaitingFunds = "AwaitingFunds",
  Inactive = "Inactive",
}

export type EntityListOfRegistrationRequestListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: RegistrationRequestListItemDto[];
};

export type RegistrationRequestListItemDto = {
  registrationRequestID: string;
  type: RegistrationRequestType;
  status: RegistrationRequestStatus;
  firstName: string;
  lastName: string;
  company?: string | null;
  email: string;
  phone: string;
  dateCreated: string;
};

export enum RegistrationRequestType {
  Partner = "Partner",
  Actor = "Actor",
}

export enum RegistrationRequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Resolved = "Resolved",
}

export enum RegistrationRequestListOrderBy {
  DateCreated = "DateCreated",
  Name = "Name",
  Type = "Type",
  Status = "Status",
}

export type RegistrationRequestDetailDto = {
  registrationRequestID: string;
  type: RegistrationRequestType;
  status: RegistrationRequestStatus;
  firstName: string;
  lastName: string;
  company?: string | null;
  email: string;
  phone: string;
  dateCreated: string;
};

export type ResolveRegistrationRequestCommandResult = {};

export type ApiProblemDetailsOfResolveRegistrationRequestErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum ResolveRegistrationRequestErrorStatus {
  NotFound = "NotFound",
  AlreadyResolved = "AlreadyResolved",
}

export type EntityListOfDocumentListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: DocumentListItemDto[];
};

export type DocumentListItemDto = {
  documentID: string;
  fileID: string;
  displayName?: string | null;
  fileName: string;
  size: number;
  dateCreated: string;
};

export type UploadProjectDocumentCommandResult = {
  projectDocumentID: string;
  fileID: string;
};

export type ApiProblemDetailsOfDocumentUploadErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum DocumentUploadErrorStatus {
  EntityNotFound = "EntityNotFound",
  FileTooLarge = "FileTooLarge",
  InvalidFileType = "InvalidFileType",
}

export type DocumentUploadRequest = {
  file: File;
  displayName?: string | null;
};

export type DeleteProjectDocumentCommandResult = {};

export type SaveProjectCommandResult = {
  projectID: string;
};

export type ApiProblemDetailsOfSaveProjectErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveProjectErrorStatus {
  ClientNotFound = "ClientNotFound",
  ClientInactive = "ClientInactive",
  ModuleNotFound = "ModuleNotFound",
  CurrentUserNotConnectWithPartner = "CurrentUserNotConnectWithPartner",
  ProjectNotFound = "ProjectNotFound",
  DuplicateExclusiveContractActor = "DuplicateExclusiveContractActor",
  ExclusiveContractActorNotFound = "ExclusiveContractActorNotFound",
  ExclusiveContractActorIndustryNotAllowed = "ExclusiveContractActorIndustryNotAllowed",
}

export type SaveProjectRequest = {
  clientID: string;
  moduleID: string;
  name: string;
  industry: Industry;
  language: LanguageCodes;
  licensedCountries: CountryCodes[];
  jobsLimit: number;
  startDate?: string | null;
  endDate?: string | null;
  exclusiveContracts: ExclusiveContractRequest[];
};

export enum Industry {
  Retail = "Retail",
  Finance = "Finance",
  Automotive = "Automotive",
  Ecommerce = "Ecommerce",
  EnergyAndUtilities = "EnergyAndUtilities",
  Pharmaceuticals = "Pharmaceuticals",
  Gaming = "Gaming",
  LogisticsAndTransport = "LogisticsAndTransport",
  MediaAndEntertainment = "MediaAndEntertainment",
  FashionAndLifestyle = "FashionAndLifestyle",
  RealEstate = "RealEstate",
  NonProfit = "NonProfit",
  HospitalityAndTourism = "HospitalityAndTourism",
  Insurance = "Insurance",
  FoodAndGastronomy = "FoodAndGastronomy",
  LegalServices = "LegalServices",
  AdvertisingAndMarketing = "AdvertisingAndMarketing",
  SportsAndFitness = "SportsAndFitness",
  TechnologyAndIT = "TechnologyAndIT",
  Telecommunications = "Telecommunications",
  PublicSector = "PublicSector",
  Education = "Education",
  Healthcare = "Healthcare",
  Other = "Other",
}

export enum CountryCodes {
  AT = "AT",
  BE = "BE",
  BG = "BG",
  CY = "CY",
  CZ = "CZ",
  DE = "DE",
  DK = "DK",
  EE = "EE",
  ES = "ES",
  FI = "FI",
  FR = "FR",
  GR = "GR",
  HR = "HR",
  HU = "HU",
  IE = "IE",
  IT = "IT",
  LT = "LT",
  LU = "LU",
  LV = "LV",
  MT = "MT",
  NL = "NL",
  PL = "PL",
  PT = "PT",
  RO = "RO",
  SE = "SE",
  SI = "SI",
  SK = "SK",
}

export type ExclusiveContractRequest = {
  actorID: string;
  price: number;
  jobLimit?: number | null;
};

export type EntityListOfProjectsListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ProjectsListItemDto[];
};

export type ProjectsListItemDto = {
  projectID: string;
  name: string;
  clientID?: string | null;
  clientName?: string | null;
  moduleID: string;
  moduleName: string;
  moduleType: ModuleType;
  industry: Industry;
  language?: LanguageCodes | null;
  licensedCountries: CountryCodes[];
  jobsLimit: number;
  jobsCount: number;
  startDate?: string | null;
  endDate?: string | null;
  projectState: ProjectState;
  dateCreated: string;
  dateUpdated: string;
};

export enum ModuleType {
  SingleVoiceSpot = "SingleVoiceSpot",
  MultiVoiceSpot = "MultiVoiceSpot",
}

export enum SortableColumn {
  Name = "Name",
  ClientName = "ClientName",
  ProjectState = "ProjectState",
  DateCreated = "DateCreated",
  DateUpdated = "DateUpdated",
  Industry = "Industry",
}

export type ProjectDetailDto = {
  projectID: string;
  name: string;
  clientID?: string | null;
  clientName?: string | null;
  moduleID: string;
  moduleName: string;
  moduleType: ModuleType;
  moduleVoiceLlms: VoiceLlm[];
  priceCategoryID: string;
  hasBlockingJobsForActorChange: boolean;
  industry: Industry;
  language?: LanguageCodes | null;
  licensedCountries: CountryCodes[];
  jobsLimit: number;
  startDate?: string | null;
  endDate?: string | null;
  projectState: ProjectState;
  dateCreated: string;
  dateUpdated: string;
  actors: ProjectActorDto[];
  hasExclusiveContracts: boolean;
  priceCategoryType: PriceCategoryType;
};

export type ProjectActorDto = {
  actorID: string;
  userID: string;
  firstName: string;
  lastName: string;
  profilePictureUrl?: string | null;
  isExclusiveContract: boolean;
  exclusiveContractPrice?: number | null;
  exclusiveContractJobLimit?: number | null;
  estimatedPrice: number;
  hasBlockingJobs: boolean;
};

export enum PriceCategoryType {
  PerMinute = "PerMinute",
  PerJob = "PerJob",
}

export type SyncProjectActorsCommandResult = {
  actorsAdded: number;
  actorsRemoved: number;
};

export type ApiProblemDetailsOfSyncProjectActorsErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SyncProjectActorsErrorStatus {
  ProjectNotFound = "ProjectNotFound",
  ActorsNotFound = "ActorsNotFound",
  ActorPriceCategoryNotAllowed = "ActorPriceCategoryNotAllowed",
  ActorNotOpenToCollaboration = "ActorNotOpenToCollaboration",
  TooManyActorsForSingleVoiceSpot = "TooManyActorsForSingleVoiceSpot",
  CannotChangeActorWithCompletedJobs = "CannotChangeActorWithCompletedJobs",
  ActorIndustryNotAllowed = "ActorIndustryNotAllowed",
  CannotRemoveActorWithActiveJobs = "CannotRemoveActorWithActiveJobs",
}

export type SyncProjectActorsRequest = {
  actorIDs: string[];
};

export type ProjectActorVoiceListItemDto = {
  actorVoiceID: string;
  actorID: string;
  actorName: string;
  voiceName: string;
  voiceLlm: VoiceLlm;
  language: LanguageCodes;
  voiceStatus: ActorVoiceStatus;
  actorStatus: ActorStatus;
};

export enum ActorVoiceStatus {
  Draft = "Draft",
  UploadingTrainingFiles = "UploadingTrainingFiles",
  TrainingInProcess = "TrainingInProcess",
  TrainingCompleted = "TrainingCompleted",
  TrainingFailed = "TrainingFailed",
  TrainingVerificationRequired = "TrainingVerificationRequired",
  Active = "Active",
  Inactive = "Inactive",
}

export enum ActorStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export type EntityListOfPriceCategoryListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: PriceCategoryListItemDto[];
};

export type PriceCategoryListItemDto = {
  priceCategoryID: string;
  name: string;
  type: PriceCategoryType;
  commissionRate: number;
  defaultPrice: number;
  status: PriceCategoryStatus;
  dateCreated: string;
  dateUpdated: string;
};

export enum PriceCategoryStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum PriceCategoryListSortColumn {
  Name = "Name",
  Type = "Type",
  DateCreated = "DateCreated",
  DateUpdated = "DateUpdated",
}

export type SavePriceCategoryCommandResult = {
  priceCategoryID: string;
};

export type ApiProblemDetailsOfSavePriceCategoryErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SavePriceCategoryErrorStatus {
  PriceCategoryNotFound = "PriceCategoryNotFound",
  NameAlreadyExists = "NameAlreadyExists",
  CommissionRateOutOfRange = "CommissionRateOutOfRange",
}

export type SavePriceCategoryRequest = {
  name: string;
  defaultPrice: number;
  commissionRate: number;
  type: PriceCategoryType;
};

export type UpdatePriceCategoryStatusCommandResult = {};

export type UpdatePriceCategoryStatusRequest = {
  status: PriceCategoryStatus;
};

export type UploadPartnerDocumentCommandResult = {
  partnerDocumentID: string;
  fileID: string;
};

export type DeletePartnerDocumentCommandResult = {};

export type EntityListOfPartnerMediaFileListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: PartnerMediaFileListItemDto[];
};

export type PartnerMediaFileListItemDto = {
  partnerMediaFileID: string;
  fileID: string;
  displayName?: string | null;
  fileName: string;
  durationSeconds?: number | null;
  dateCreated: string;
};

export enum PartnerMediaFileSortColumn {
  DisplayName = "DisplayName",
  FileName = "FileName",
  Duration = "Duration",
  DateCreated = "DateCreated",
}

export type CreatePartnerMediaFileCommandResult = {
  partnerMediaFileID: string;
  fileID: string;
};

export type ApiProblemDetailsOfCreatePartnerMediaFileErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum CreatePartnerMediaFileErrorStatus {
  FileTooLarge = "FileTooLarge",
  InvalidFileType = "InvalidFileType",
  PartnerNotFound = "PartnerNotFound",
  LicenseNotConfirmed = "LicenseNotConfirmed",
}

export type CreatePartnerMediaFileRequest = {
  file: File;
  displayName: string;
  licenseConfirmed: boolean;
};

export type DeletePartnerMediaFileCommandResult = {};

export type TogglePartnerModuleCommandResult = {
  isEnabled: boolean;
};

export type ApiProblemDetailsOfTogglePartnerModuleErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum TogglePartnerModuleErrorStatus {
  PartnerNotFound = "PartnerNotFound",
  ModuleNotFound = "ModuleNotFound",
  AlreadyEnabled = "AlreadyEnabled",
  AlreadyDisabled = "AlreadyDisabled",
}

export type TogglePartnerModuleRequest = {
  enable: boolean;
};

export type SetPartnerModulesCommandResult = {};

export type ApiProblemDetailsOfSetPartnerModulesErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SetPartnerModulesErrorStatus {
  PartnerNotFound = "PartnerNotFound",
  ModuleNotFound = "ModuleNotFound",
}

export type SetPartnerModulesRequest = {
  moduleIDs: string[];
};

export type EntityListOfModuleWithPartnerStatusListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ModuleWithPartnerStatusListItemDto[];
};

export type ModuleWithPartnerStatusListItemDto = {
  moduleID: string;
  name: string;
  type: ModuleType;
  isEnabledForPartner: boolean;
};

export type EntityListOfPartnerWithModuleStatusListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: PartnerWithModuleStatusListItemDto[];
};

export type PartnerWithModuleStatusListItemDto = {
  partnerID: string;
  companyName: string;
  isEnabledForModule: boolean;
};

export type SetModulePartnersCommandResult = {};

export type ApiProblemDetailsOfSetModulePartnersErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SetModulePartnersErrorStatus {
  ModuleNotFound = "ModuleNotFound",
  PartnerNotFound = "PartnerNotFound",
}

export type SetModulePartnersRequest = {
  partnerIDs: string[];
};

export type EntityListOfEnabledModuleListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: EnabledModuleListItemDto[];
};

export type EnabledModuleListItemDto = {
  moduleID: string;
  name: string;
  type: ModuleType;
};

export type EntityListOfPartnerListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: PartnerListItemDto[];
};

export type PartnerListItemDto = {
  partnerID: string;
  companyName: string;
  email?: string | null;
  phone?: string | null;
  projectCount: number;
  status: PartnerStatus;
  childPartners?: PartnerListItemDto[] | null;
};

export enum PartnerStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export enum PartnerListSortColumn {
  CompanyName = "CompanyName",
  ProjectCount = "ProjectCount",
  Email = "Email",
  Phone = "Phone",
}

export type EntityListOfPartnerSupervisorSearchListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: PartnerSupervisorSearchListItemDto[];
};

export type PartnerSupervisorSearchListItemDto = {
  partnerID: string;
  companyName: string;
};

export type PartnerDetailDto = {
  partnerID: string;
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  email?: string | null;
  phone?: string | null;
  address?: AddressDto | null;
  allowRetroactivePayment: boolean;
  status: PartnerStatus;
  parentPartnerID?: string | null;
  parentPartnerName?: string | null;
  projects: PartnerDetailProjectListItemDto[];
  enabledModules: PartnerDetailEnabledModulesListItemDto[];
  clients: PartnerDetailClientListItemDto[];
};

export type AddressDto = {
  street?: string | null;
  streetNumber?: string | null;
  orientationNumber?: string | null;
  postalCode: string;
  municipality: string;
  countryCode: CountryCodes;
};

export type PartnerDetailProjectListItemDto = {
  projectID: string;
  name: string;
  state: ProjectState;
  moduleType: ModuleType;
};

export type PartnerDetailEnabledModulesListItemDto = {
  moduleID: string;
  type: ModuleType;
  name: string;
  status: ModuleStatus;
};

export enum ModuleStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export type PartnerDetailClientListItemDto = {
  clientID: string;
  companyName: string;
  status: ClientStatus;
};

export enum ClientStatus {
  Active = "Active",
  Inactive = "Inactive",
}

export type SavePartnerCommandResult = {
  partnerID: string;
};

export type ApiProblemDetailsOfSavePartnerErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SavePartnerErrorStatus {
  ParentPartnerNotFound = "ParentPartnerNotFound",
  HierarchyTooDeep = "HierarchyTooDeep",
  CannotSetParentWithChildren = "CannotSetParentWithChildren",
  CannotBeSelfParent = "CannotBeSelfParent",
  UserWithLoginAlreadyExists = "UserWithLoginAlreadyExists",
}

export type SavePartnerRequest = {
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  email: string;
  phone: string;
  address: SaveAddressDto;
  allowRetroactivePayment: boolean;
  parentPartnerID?: string | null;
};

export type SaveAddressDto = {
  street?: string | null;
  streetNumber?: string | null;
  orientationNumber?: string | null;
  postalCode: string;
  municipality: string;
  countryCode: CountryCodes;
};

export type UpdatePartnerStatusCommandResult = {};

export type ApiProblemDetailsOfUpdatePartnerStatusErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum UpdatePartnerStatusErrorStatus {
  HasActiveChildren = "HasActiveChildren",
}

export type UpdatePartnerStatusRequest = {
  status: PartnerStatus;
};

export type EntityListOfModuleListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ModuleListItemDto[];
};

export type ModuleListItemDto = {
  moduleID: string;
  type: ModuleType;
  status: ModuleStatus;
  name: string;
  projectCount: number;
  dateUpdated: string;
};

export enum ModuleListSortColumn {
  Name = "Name",
  Type = "Type",
  ProjectCount = "ProjectCount",
}

export type ModuleDetailDto = {
  moduleID: string;
  name: string;
  type: ModuleType;
  priceCategoryID: string;
  status: ModuleStatus;
  customPrompt: string;
  customPromptPlainText: string;
  textLlms: TextLlm[];
  voiceLlms: VoiceLlm[];
};

export enum TextLlm {
  OpenAI_ChatGpt5 = "OpenAI_ChatGpt5",
}

export type SaveModuleCommandResult = {
  moduleID: string;
};

export type ApiProblemDetailsOfSaveModuleErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveModuleErrorStatus {
  PriceCategoryNotFound = "PriceCategoryNotFound",
}

export type SaveModuleRequest = {
  name: string;
  type: ModuleType;
  priceCategoryID: string;
  customPrompt: string;
  customPromptPlainText: string;
  textLlms: TextLlm[];
  voiceLlms: VoiceLlm[];
};

export type ModuleQuestionDto = {
  moduleQuestionID: string;
  text: string;
  type: ModuleQuestionType;
  sortOrder: number;
  isRequired: boolean;
  options: ModuleQuestionOptionDto[];
};

export enum ModuleQuestionType {
  Text = "Text",
  SingleChoice = "SingleChoice",
  MultiChoice = "MultiChoice",
  SingleChoiceWithOther = "SingleChoiceWithOther",
  MultiChoiceWithOther = "MultiChoiceWithOther",
}

export type ModuleQuestionOptionDto = {
  moduleQuestionOptionID: string;
  text: string;
  sortOrder: number;
};

export type SaveModuleQuestionsCommandResult = {};

export type ApiProblemDetailsOfSaveModuleQuestionsErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveModuleQuestionsErrorStatus {
  ModuleNotFound = "ModuleNotFound",
  InvalidQuestionConfiguration = "InvalidQuestionConfiguration",
}

export type SaveModuleQuestionsRequest = {
  questions: SaveModuleQuestionItem[];
};

export type SaveModuleQuestionItem = {
  text: string;
  type: ModuleQuestionType;
  isRequired: boolean;
  sortOrder: number;
  options: SaveModuleQuestionOptionItem[];
};

export type SaveModuleQuestionOptionItem = {
  text: string;
  sortOrder: number;
};

export type EntityListOfJobListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: JobListItemDto[];
};

export type JobListItemDto = {
  jobID: string;
  projectID: string;
  name: string;
  dateCreated: string;
  dateUpdated: string;
  status: JobStatus;
};

export type JobDetailDto = {
  jobID: string;
  projectID: string;
  projectName: string;
  clientName?: string | null;
  moduleID: string;
  moduleName: string;
  moduleType: ModuleType;
  name: string;
  script?: JobScript | null;
  questionAnswers?: JobQuestionAnswersDto | null;
  status: JobStatus;
  dateCreated: string;
  dateUpdated: string;
  finalizedByUserID?: string | null;
  finalizedAt?: string | null;
  finalClipFileID?: string | null;
  clips: JobDetailClipListItemDto[];
};

export type JobScript = {
  version: JobScriptVersion;
  audioOutputOptions: AudioOutputOptions;
  variables: ScriptVariable[];
  segments: ScriptSegment[];
  globalSpeedFactor: number;
  globalVolumePercent: number;
  defaultActorVoiceID?: string | null;
  defaultLanguage?: LanguageCodes | null;
};

export enum JobScriptVersion {
  V1 = "V1",
}

export type AudioOutputOptions = {
  format: AudioFormat;
  sampleRate: AudioSampleRate;
  channels: AudioChannels;
  bitrate: AudioBitrate;
};

export enum AudioFormat {
  Wav = "Wav",
  Mp3 = "Mp3",
}

export enum AudioSampleRate {
  Hz22050 = "Hz22050",
  Hz44100 = "Hz44100",
  Hz48000 = "Hz48000",
}

export enum AudioChannels {
  Mono = "Mono",
  Stereo = "Stereo",
}

export enum AudioBitrate {
  Kbps64 = "Kbps64",
  Kbps128 = "Kbps128",
  Kbps192 = "Kbps192",
  Kbps256 = "Kbps256",
  Kbps320 = "Kbps320",
}

export type ScriptVariable = {
  name: string;
  defaultValue: string;
};

export type ScriptSegment = VoiceSegment | PauseSegment | MediaSegment;

export type VoiceSegment = {
  actorVoiceID: string;
  languageOverride?: LanguageCodes | null;
  speedFactor: number;
  volumePercent: number;
  spans: VoiceSpan[];
};

export type VoiceSpan = {
  text: string;
  style?: VoiceStyle | null;
  reaction?: VoiceReactionTag | null;
  reactionVolumeEnergy?: VoiceReactionVolumeEnergyTag | null;
  reactionPacingRhythm?: VoiceReactionPacingRhythmTag | null;
  customReaction?: string | null;
};

export enum VoiceStyle {
  Neutral = "Neutral",
  Cheerful = "Cheerful",
  Excited = "Excited",
  Friendly = "Friendly",
  Sad = "Sad",
  Angry = "Angry",
  Calm = "Calm",
  Newscast = "Newscast",
  Whispering = "Whispering",
  Authoritative = "Authoritative",
  Empathetic = "Empathetic",
}

export enum VoiceReactionTag {
  Gasp = "Gasp",
  Sigh = "Sigh",
  Laughs = "Laughs",
  Gulps = "Gulps",
  Crying = "Crying",
  EvilLaugh = "EvilLaugh",
  Hums = "Hums",
  Giggle = "Giggle",
}

export enum VoiceReactionVolumeEnergyTag {
  Whispering = "Whispering",
  Shouting = "Shouting",
  Quietly = "Quietly",
  Loudly = "Loudly",
  Sings = "Sings",
  Sarcastic = "Sarcastic",
}

export enum VoiceReactionPacingRhythmTag {
  Stammers = "Stammers",
  Rushed = "Rushed",
}

export type PauseSegment = {
  durationMs: number;
};

export type MediaSegment = {
  partnerMediaFileID: string;
  volumePercent: number;
  startAtMs: number;
  durationMs?: number | null;
};

export type JobQuestionAnswersDto = {
  answers: JobQuestionAnswerDto[];
};

export type JobQuestionAnswerDto = {
  moduleQuestionID: string;
  questionText: string;
  textAnswer?: string | null;
  selectedOptions: string[];
};

export type JobDetailClipListItemDto = {
  jobClipID: string;
  fileID: string;
  durationSeconds?: number | null;
  fileName: string;
  dateCreated: string;
  type: JobClipType;
  actorCost: number;
  price: number;
};

export enum JobClipType {
  Preview = "Preview",
  Full = "Full",
  Final = "Final",
}

export type CreateJobCommandResult = {
  jobID: string;
};

export type ApiProblemDetailsOfCreateJobErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum CreateJobErrorStatus {
  ProjectNotFound = "ProjectNotFound",
  JobsLimitExceeded = "JobsLimitExceeded",
}

export type CreateJobRequest = {
  name: string;
};

export type SaveJobScriptCommandResult = {};

export type ApiProblemDetailsOfSaveJobScriptErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveJobScriptErrorStatus {
  JobNotFound = "JobNotFound",
}

export type SaveJobAnswersCommandResult = {};

export type ApiProblemDetailsOfSaveJobAnswersErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveJobAnswersErrorStatus {
  JobNotFound = "JobNotFound",
  MissingRequiredAnswer = "MissingRequiredAnswer",
  InvalidOption = "InvalidOption",
  InvalidQuestion = "InvalidQuestion",
  TooManyOptionsForSingleChoice = "TooManyOptionsForSingleChoice",
}

export type SaveJobAnswersRequest = {
  answers: SaveJobAnswerItem[];
};

export type SaveJobAnswerItem = {
  moduleQuestionID: string;
  textAnswer?: string | null;
  selectedOptionIDs?: string[] | null;
};

export type ApiProblemDetailsOfGenerateVoicelinesErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum GenerateVoicelinesErrorStatus {
  ProjectNotFound = "ProjectNotFound",
  JobNotFound = "JobNotFound",
  UnsupportedTextLlm = "UnsupportedTextLlm",
  GenerationFailed = "GenerationFailed",
  RateLimited = "RateLimited",
}

export type GenerateVoicelinesCommandResult = {
  generatedContent: string;
};

export type GenerateVoicelinesRequest = {
  textLlm: TextLlm;
  instructions: string;
  context?: string | null;
};

export type ApiProblemDetailsOfGenerateJobClipErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum GenerateJobClipErrorStatus {
  JobNotFound = "JobNotFound",
  ScriptNotFound = "ScriptNotFound",
  GenerationFailed = "GenerationFailed",
  ExclusiveContractJobLimitReached = "ExclusiveContractJobLimitReached",
}

export type GenerateJobClipCommandResult = {
  jobClipID: string;
  fileID: string;
  fileName: string;
  fileDownloadUrl: string;
  actorCost: number;
  price: number;
};

export type ApiProblemDetailsOfJobScriptValidationError = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum JobScriptValidationError {
  InvalidScript = "InvalidScript",
  DuplicateVariableName = "DuplicateVariableName",
  ActorVoiceNotFound = "ActorVoiceNotFound",
  ActorVoiceNotConfigured = "ActorVoiceNotConfigured",
  ActorNotAssignedToProject = "ActorNotAssignedToProject",
  PartnerMediaFileNotFound = "PartnerMediaFileNotFound",
  ConflictingReactionFields = "ConflictingReactionFields",
  InvalidCustomReactionLength = "InvalidCustomReactionLength",
  InvalidCustomReactionCharacters = "InvalidCustomReactionCharacters",
}

export type GenerateJobClipRequest = {
  type: GenerateJobClipRequestType;
  script: JobScript;
};

export enum GenerateJobClipRequestType {
  Preview = "Preview",
  Full = "Full",
}

export type RetryFinalizationCommandResult = {
  jobID: string;
  status: JobStatus;
};

export type ApiProblemDetailsOfRetryFinalizationErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum RetryFinalizationErrorStatus {
  JobNotFound = "JobNotFound",
  InvalidJobStatus = "InvalidJobStatus",
  NotAllApproved = "NotAllApproved",
  InsufficientBalance = "InsufficientBalance",
  FinalizationFailed = "FinalizationFailed",
}

export type UpdateJobStatusCommandResult = {};

export type UpdateJobStatusRequest = {
  isActive: boolean;
};

export type SubmitJobCommandResult = {
  jobID: string;
  status: JobStatus;
};

export type ApiProblemDetailsOfSubmitJobErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SubmitJobErrorStatus {
  JobNotFound = "JobNotFound",
  ClipNotFound = "ClipNotFound",
  ClipNotFullType = "ClipNotFullType",
  JobNotSubmittable = "JobNotSubmittable",
  InsufficientBalance = "InsufficientBalance",
  FinalizationFailed = "FinalizationFailed",
}

export type SubmitJobRequest = {
  jobClipID: string;
};

export type ExchangeRateDto = {
  currency: CurrencyCodes;
  rate: number;
  rateDate: string;
};

export type UploadFileCommandResult = {
  fileID: string;
};

export type ApiProblemDetailsOfUploadFileCommandResultError = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum UploadFileCommandResultError {
  FileTooLarge = "FileTooLarge",
}

export type UploadFileRequest = {
  file: File;
};

export type GetFileDownloadUrlQueryResult = {
  downloadUrl: string;
  fileName: string;
  mimeType?: string | null;
};

export type ApiProblemDetailsOfGetFileDownloadUrlErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum GetFileDownloadUrlErrorStatus {
  FileNotFound = "FileNotFound",
}

export type UploadClientDocumentCommandResult = {
  clientDocumentID: string;
  fileID: string;
};

export type DeleteClientDocumentCommandResult = {};

export type EntityListOfClientListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ClientListItemDto[];
};

export type ClientListItemDto = {
  clientID: string;
  companyName: string;
  partnerName: string;
  projectCount: number;
  email?: string | null;
  phone?: string | null;
  status: ClientStatus;
};

export enum ClientListSortColumn {
  CompanyName = "CompanyName",
  PartnerName = "PartnerName",
  ProjectCount = "ProjectCount",
  Email = "Email",
  Phone = "Phone",
}

export type ClientDetailDto = {
  clientID: string;
  partnerID: string;
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  email?: string | null;
  phone?: string | null;
  address?: AddressDto | null;
  status: ClientStatus;
  projects: ClientProjectDto[];
};

export type ClientProjectDto = {
  projectID: string;
  name: string;
  state: ProjectState;
  moduleType: ModuleType;
};

export type SaveClientCommandResult = {
  clientID: string;
};

export type ApiProblemDetailsOfSaveClientErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveClientErrorStatus {
  CompanyNumberAlreadyExists = "CompanyNumberAlreadyExists",
  UnauthorizedAccess = "UnauthorizedAccess",
  PartnerRequired = "PartnerRequired",
}

export type SaveClientRequest = {
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  email: string;
  phone: string;
  address: SaveAddressDto;
};

export type UpdateClientStatusCommandResult = {};

export type UpdateClientStatusRequest = {
  status: ClientStatus;
};

export type PartnerBalanceResult = {
  accountID: string;
  balance: number;
};

export type EntityListOfTransactionListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: TransactionListItemDto[];
};

export type TransactionListItemDto = {
  walletTransactionID: string;
  transactionType: TransactionType;
  direction: EntryDirection;
  amount: number;
  balanceAfter: number;
  description?: string | null;
  effectiveAt: string;
  dateCreated: string;
  invoiceID?: string | null;
};

export enum TransactionType {
  Deposit = "Deposit",
  JobPayment = "JobPayment",
  Withdrawal = "Withdrawal",
  Reversal = "Reversal",
  Adjustment = "Adjustment",
}

export enum EntryDirection {
  Debit = "Debit",
  Credit = "Credit",
}

export type InitiateDepositCommandResult = {
  paymentIntentID: string;
  checkoutUrl: string;
};

export type ApiProblemDetailsOfInitiateDepositErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum InitiateDepositErrorStatus {
  PartnerRequired = "PartnerRequired",
  IdempotencyKeyRequired = "IdempotencyKeyRequired",
  InvalidAmount = "InvalidAmount",
}

export type InitiateDepositRequest = {
  amount: number;
  description?: string | null;
  idempotencyKey: string;
};

export type EntityListOfInvoiceListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: InvoiceListItemDto[];
};

export type InvoiceListItemDto = {
  invoiceID: string;
  invoiceNumber: string;
  invoiceType: InvoiceType;
  status: InvoiceStatus;
  issueDate: string;
  sellerName: string;
  buyerName: string;
  totalGrossAmount: number;
  currency: CurrencyCodes;
};

export enum InvoiceType {
  Standard = "Standard",
  SelfBilling = "SelfBilling",
  CreditNote = "CreditNote",
}

export enum InvoiceStatus {
  Issued = "Issued",
  Paid = "Paid",
  Cancelled = "Cancelled",
}

export type EntityListOfWithdrawalListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: WithdrawalListItemDto[];
};

export type WithdrawalListItemDto = {
  withdrawalRequestID: string;
  approvalToken: string;
  actorName?: string | null;
  amount: number;
  iban?: string | null;
  status: WithdrawalRequestStatus;
  requestedAt: string;
  resolvedAt?: string | null;
  expiresAt: string;
  rejectionReason?: string | null;
  resolvedByUserName?: string | null;
  invoiceID?: string | null;
};

export enum WithdrawalRequestStatus {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Expired = "Expired",
}

export enum WithdrawalListOrderBy {
  RequestedAt = "RequestedAt",
  Amount = "Amount",
  Status = "Status",
  ActorName = "ActorName",
}

export type WithdrawalApprovalDetailDto = {
  amount: number;
  iban?: string | null;
  swift?: string | null;
  status: WithdrawalRequestStatus;
  requestedAt: string;
  resolvedAt?: string | null;
  expiresAt: string;
  rejectionReason?: string | null;
  actorName?: string | null;
  actorBalance: number;
  resolvedByUserName?: string | null;
  invoiceID?: string | null;
};

export type ApproveWithdrawalCommandResult = {
  withdrawalRequestID: string;
};

export type ApiProblemDetailsOfApproveWithdrawalErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum ApproveWithdrawalErrorStatus {
  NotFound = "NotFound",
  AlreadyProcessed = "AlreadyProcessed",
  Expired = "Expired",
  LedgerError = "LedgerError",
}

export type RejectWithdrawalCommandResult = {
  withdrawalRequestID: string;
};

export type ApiProblemDetailsOfRejectWithdrawalErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum RejectWithdrawalErrorStatus {
  NotFound = "NotFound",
  AlreadyProcessed = "AlreadyProcessed",
}

export type RejectWithdrawalRequest = {
  reason: string;
};

export type RegisterPartnerCommandResult = {};

export type ApiProblemDetailsOfRegisterPartnerErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum RegisterPartnerErrorStatus {
  UserExists = "UserExists",
  DuplicateRequest = "DuplicateRequest",
}

export type RegisterPartnerRequest = {
  firstName: string;
  lastName: string;
  company: string;
  login: string;
  phone: string;
};

export type RegisterActorCommandResult = {};

export type ApiProblemDetailsOfRegisterActorErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum RegisterActorErrorStatus {
  UserExists = "UserExists",
  DuplicateRequest = "DuplicateRequest",
}

export type RegisterActorRequest = {
  firstName: string;
  lastName: string;
  company?: string | null;
  login: string;
  phone: string;
};

export type SignInResult = {
  userInfo: UserInfo;
  isFirstSignIn: boolean;
};

export type UserInfo = {
  userID: string;
  token: string;
  login: string;
  firstName: string;
  lastName: string;
  accessRightCodes: AccessRightCode[];
  profilePicture?: string | null;
  userAccessRoles: AccessRoleCode[];
  partnerID?: string | null;
  partnerParentID?: string | null;
  partnerName?: string | null;
  language?: LanguageCodes | null;
  currency: CurrencyCodes;
};

export enum AccessRightCode {
  SysAdmin = "SysAdmin",
}

export enum AccessRoleCode {
  SysAdmin = "SysAdmin",
  Partner = "Partner",
  Actor = "Actor",
}

export type ApiProblemDetailsOfAuthError = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum AuthError {
  ApplicationVerification = "ApplicationVerification",
  InvalidCredentials = "InvalidCredentials",
  AccountIsDisabled = "AccountIsDisabled",
  PhoneNumberNotFound = "PhoneNumberNotFound",
  SmsSendingFailed = "SmsSendingFailed",
  InvalidToken = "InvalidToken",
  AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation",
  InsufficientRole = "InsufficientRole",
  AccountWaitingForSetPassword = "AccountWaitingForSetPassword",
}

export type SignInRequest = {
  login: string;
  password: string;
};

export type SsoSignInRequest = {
  token: string;
  identityProvider: IdentityProvider;
};

export type ResetPasswordCommandResult = {};

export type ApiProblemDetailsOfResetPasswordCommandResultStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum ResetPasswordCommandResultStatus {
  Fail = "Fail",
}

export type ResetPasswordCommand = {
  login: string;
};

export type SetPasswordCommandResult = {
  signInResult: SignInResult;
};

export type ApiProblemDetailsOfSetPasswordCommandStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SetPasswordCommandStatus {
  TokenNotFound = "TokenNotFound",
}

export type ApiProblemDetailsOfPasswordChangeResultStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum PasswordChangeResultStatus {
  PasswordNotMatch = "PasswordNotMatch",
  NullOrEmpty = "NullOrEmpty",
  TooShort = "TooShort",
  Success = "Success",
}

export type SetPasswordCommand = {
  token: string;
  password: string;
};

export type DetectAudioWatermarkCommandResult = {
  hasWatermark: boolean;
};

export type ApiProblemDetailsOfDetectAudioWatermarkErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum DetectAudioWatermarkErrorStatus {
  InvalidFileType = "InvalidFileType",
  UnsupportedAudioFormat = "UnsupportedAudioFormat",
}

export type DetectAudioWatermarkRequest = {
  file: File;
};

export type UploadActorDocumentCommandResult = {
  actorDocumentID: string;
  fileID: string;
};

export type DeleteActorDocumentCommandResult = {};

export type ActorPriceCategoryListItemDto = {
  actorPriceCategoryID: string;
  priceCategoryID: string;
  priceCategoryName: string;
  price: number;
  commissionRate: number;
  finalPrice: number;
  note?: string | null;
  status: ActorPriceCategoryStatus;
  approvalType?: ActorPriceCategoryApprovalType | null;
  startDate?: string | null;
  endDate?: string | null;
  defaultPrice?: number | null;
  priceCategoryType: PriceCategoryType;
};

export enum ActorPriceCategoryStatus {
  NotAllowed = "NotAllowed",
  Allowed = "Allowed",
  Exclusive = "Exclusive",
}

export enum ActorPriceCategoryApprovalType {
  Manual = "Manual",
  Automatic = "Automatic",
}

export type SaveActorPriceCategoriesCommandResult = {};

export type ApiProblemDetailsOfSaveActorPriceCategoriesErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveActorPriceCategoriesErrorStatus {
  PriceCategoryNotFound = "PriceCategoryNotFound",
}

export type SaveActorPriceCategoriesRequest = {
  items: SaveActorPriceCategoryItemRequest[];
};

export type SaveActorPriceCategoryItemRequest = {
  priceCategoryID: string;
  price: number;
  note?: string | null;
  status: ActorPriceCategoryStatus;
  approvalType?: ActorPriceCategoryApprovalType | null;
};

export type EntityListOfActorPriceCategoryListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ActorPriceCategoryListItemDto[];
};

export type EntityListOfActorListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ActorListItemDto[];
};

export type ActorListItemDto = {
  actorID: string;
  name: string;
  profilePictureUrl?: string | null;
  language: LanguageCodes;
  gender?: GenderType | null;
  age?: number | null;
  price?: number | null;
  czechPreviewFileID?: string | null;
  englishPreviewFileID?: string | null;
  deutschPreviewFileID?: string | null;
  status: ActorStatus;
};

export enum GenderType {
  Male = "Male",
  Female = "Female",
}

export enum ActorListOrderBy {
  Name = "Name",
  Language = "Language",
  Age = "Age",
  Price = "Price",
}

export type ActorDetailDto = {
  actorID: string;
  userID: string;
  partnerID: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  birthDate?: string | null;
  gender?: GenderType | null;
  language: LanguageCodes;
  iban?: string | null;
  swift?: string | null;
  address?: AddressDto | null;
  industries: Industry[];
  hasCustomBillingDetails: boolean;
  billingDetails?: BillingDetailsDto | null;
  status: ActorStatus;
  isOpenToCollaboration: boolean;
  profilePicture?: string | null;
};

export type BillingDetailsDto = {
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  address?: AddressDto | null;
  iban?: string | null;
  swift?: string | null;
};

export type SaveActorCommandResult = {
  actorID: string;
};

export type ApiProblemDetailsOfSaveActorErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveActorErrorStatus {
  EmailAlreadyExists = "EmailAlreadyExists",
  ActorAlreadyExists = "ActorAlreadyExists",
  PartnerRequired = "PartnerRequired",
}

export type SaveActorRequest = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  birthDate: string;
  gender: GenderType;
  language: LanguageCodes;
  iban: string;
  swift: string;
  address: SaveAddressDto;
  industries: Industry[];
  hasCustomBillingDetails: boolean;
  billingDetails?: SaveBillingDetailsDto | null;
};

export type SaveBillingDetailsDto = {
  companyName: string;
  companyNumber: string;
  taxNumber: string;
  iban: string;
  swift: string;
  address: SaveAddressDto;
};

export type UpdateActorStatusCommandResult = {};

export type UpdateActorStatusRequest = {
  status: ActorStatus;
};

export type ActorVoiceListItemDto = {
  actorVoiceID: string;
  status: ActorVoiceStatus;
  name: string;
  language: LanguageCodes;
  tags?: string | null;
  previews: ActorVoicePreviewListItemDto[];
};

export type ActorVoicePreviewListItemDto = {
  fileID: string;
  language: LanguageCodes;
  duration?: string | null;
};

export type ActorVoiceDetailDto = {
  actorVoiceID: string;
  actorID: string;
  status: ActorVoiceStatus;
  name: string;
  voiceLlm: VoiceLlm;
  trainingType?: VoiceTrainingType | null;
  language: LanguageCodes;
  externalVoiceID?: string | null;
  tags?: string | null;
  trainingFilesCount: number;
  hasCaptchaFile: boolean;
  previews: ActorVoicePreviewListItemDto[];
};

export enum VoiceTrainingType {
  ElevenLabs_Instant = "ElevenLabs_Instant",
  ElevenLabs_Professional = "ElevenLabs_Professional",
}

export type SaveActorVoiceCommandResult = {
  actorVoiceID: string;
};

export type ApiProblemDetailsOfSaveActorVoiceErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum SaveActorVoiceErrorStatus {
  ActorNotFound = "ActorNotFound",
  ExternalVoiceIDEmpty = "ExternalVoiceIDEmpty",
  ActorVoiceNotFound = "ActorVoiceNotFound",
  TrainingTypeNotSupportedForVoiceLlm = "TrainingTypeNotSupportedForVoiceLlm",
  CannotChangeVoiceConfigAfterDraft = "CannotChangeVoiceConfigAfterDraft",
}

export type SaveActorVoiceRequest = {
  name: string;
  tags?: string | null;
  voiceLlm: VoiceLlm;
  trainingType?: VoiceTrainingType | null;
  language: LanguageCodes;
  externalVoiceID?: string | null;
  externalEndpoint?: string | null;
};

export type UploadActorVoiceTrainingFileCommandResult = {
  fileID: string;
  trainingFileUploadedCount: number;
  maxAvailableTrainingFiles: number;
};

export type ApiProblemDetailsOfUploadActorVoiceTrainingFileErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum UploadActorVoiceTrainingFileErrorStatus {
  FileTooLarge = "FileTooLarge",
  InvalidFileType = "InvalidFileType",
  ActorVoiceNotFound = "ActorVoiceNotFound",
  MaxFilesExceeded = "MaxFilesExceeded",
  ThisVoiceModelCannotBeTrained = "ThisVoiceModelCannotBeTrained",
  DuplicateFile = "DuplicateFile",
  CaptchaFileAlreadyExists = "CaptchaFileAlreadyExists",
  CaptchaFileNotAllowedForInstant = "CaptchaFileNotAllowedForInstant",
}

export enum ActorVoiceTrainingFileType {
  Training = "Training",
  Captcha = "Captcha",
}

export type UploadActorVoiceTrainingFileRequest = {
  file: File;
  type: ActorVoiceTrainingFileType;
};

export type DeleteActorVoiceTrainingFileCommandResult = {};

export type ApiProblemDetailsOfDeleteActorVoiceTrainingFileErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum DeleteActorVoiceTrainingFileErrorStatus {
  TrainingFileNotFound = "TrainingFileNotFound",
  WrongStatus = "WrongStatus",
}

export type DeleteAllActorVoiceTrainingFilesCommandResult = {
  deletedCount: number;
};

export type ApiProblemDetailsOfDeleteAllActorVoiceTrainingFilesErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum DeleteAllActorVoiceTrainingFilesErrorStatus {
  ActorVoiceNotFound = "ActorVoiceNotFound",
  WrongStatus = "WrongStatus",
}

export type GenerateActorVoicePreviewCommandResult = {
  previews: GenerateActorVoicePreviewItemDto[];
};

export type GenerateActorVoicePreviewItemDto = {
  fileID: string;
  language: LanguageCodes;
  duration?: string | null;
  downloadUrl: string;
};

export type ApiProblemDetailsOfGenerateActorVoicePreviewErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum GenerateActorVoicePreviewErrorStatus {
  ActorVoiceNotFound = "ActorVoiceNotFound",
  WrongStatus = "WrongStatus",
  InvalidParameters = "InvalidParameters",
  GenerationFailed = "GenerationFailed",
}

export type GenerateActorVoicePreviewRequest = {
  volumePercent: number;
  speedFactor: number;
};

export type UpdateActorVoiceStatusCommandResult = {};

export type UpdateActorVoiceStatusRequest = {
  isActive: boolean;
};

export type ApiProblemDetailsOfTrainingActorVoiceErrorStatus = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum TrainingActorVoiceErrorStatus {
  LlmModelNotSupportCustomTraining = "LlmModelNotSupportCustomTraining",
  TrainingFilesEmpty = "TrainingFilesEmpty",
  ActorVoiceNotFound = "ActorVoiceNotFound",
  WrongStatus = "WrongStatus",
  CaptchaFileRequired = "CaptchaFileRequired",
  InsufficientAudioDuration = "InsufficientAudioDuration",
}

export type EntityListOfActivityLogListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: ActivityLogListItemDto[];
};

export type ActivityLogListItemDto = {
  activityLogID: string;
  activityEventType: ActivityEventType;
  activityEntityType: ActivityEntityType;
  entityID?: string | null;
  parentEntityID?: string | null;
  note: string;
  userFullName: string;
  dateCreated: string;
};

export enum ActivityEventType {
  ActorCreated = "ActorCreated",
  ActorPriceCategoryChanged = "ActorPriceCategoryChanged",
  PartnerCreated = "PartnerCreated",
  ProjectCreated = "ProjectCreated",
  ProjectCompleted = "ProjectCompleted",
  ProjectClosed = "ProjectClosed",
  JobCompleted = "JobCompleted",
  PartnerCreditTopUp = "PartnerCreditTopUp",
  ActorPayoutApproved = "ActorPayoutApproved",
  ClientCreated = "ClientCreated",
}

export enum ActivityEntityType {
  Actor = "Actor",
  Partner = "Partner",
  Project = "Project",
  Job = "Job",
  Client = "Client",
}

export enum ActivityLogSortColumn {
  DateCreated = "DateCreated",
  UserFullName = "UserFullName",
  ActivityEventType = "ActivityEventType",
  Note = "Note",
}

export type GetExternalVoicesSearchFetchResponse =
  | FetchResponse<EntityListOfExternalVoiceListItemDto, 200>
  | FetchResponse<ApiProblemDetailsOfSearchExternalVoicesErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getExternalVoicesSearchPath = () =>
  `/api/v1/external-voices/search`;

export const getExternalVoicesSearch = (
  voiceLlm?: VoiceLlm,
  searchQuery?: string | undefined | null,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetExternalVoicesSearchFetchResponse> => {
  const queryParams = {
    voiceLlm: voiceLlm,
    searchQuery: searchQuery,
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getExternalVoicesSearchPath()}`,
    options,
    queryParams,
  ) as Promise<GetExternalVoicesSearchFetchResponse>;
};

export type GetUsersFetchResponse =
  | FetchResponse<EntityListOfUserListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUsersPath = () => `/api/v1/users`;

export const getUsers = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  sortBy?: UserListSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetUsersFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getUsersPath()}`,
    options,
    queryParams,
  ) as Promise<GetUsersFetchResponse>;
};

export type GetUsersUserIDFetchResponse =
  | FetchResponse<UserDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUsersUserIDPath = (userID: string) => `/api/v1/users/${userID}`;

export const getUsersUserID = (
  userID: string,
  options?: FetchArgsOptions,
): Promise<GetUsersUserIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getUsersUserIDPath(userID)}`,
    options,
    {},
  ) as Promise<GetUsersUserIDFetchResponse>;
};

export type DeleteUsersUserIDProfilePictureFetchResponse =
  | FetchResponse<DeleteUserProfilePictureCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfDeleteUserProfilePictureErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteUsersUserIDProfilePicturePath = (userID: string) =>
  `/api/v1/users/${userID}/profile-picture`;

export const deleteUsersUserIDProfilePicture = (
  userID: string,
  options?: FetchArgsOptions,
): Promise<DeleteUsersUserIDProfilePictureFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deleteUsersUserIDProfilePicturePath(userID)}`,
    options,
    {},
  ) as Promise<DeleteUsersUserIDProfilePictureFetchResponse>;
};

export type PutUsersUserIDProfilePictureFetchResponse =
  | FetchResponse<UploadUserProfilePictureCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfUploadUserProfilePictureErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfUploadUserProfilePictureErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUsersUserIDProfilePicturePath = (userID: string) =>
  `/api/v1/users/${userID}/profile-picture`;

export const putUsersUserIDProfilePicture = (
  requestContract: UploadUserProfilePictureRequest,
  userID: string,
  options?: FetchArgsOptions,
): Promise<PutUsersUserIDProfilePictureFetchResponse> => {
  const requestData = getApiRequestData<UploadUserProfilePictureRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putUsersUserIDProfilePicturePath(userID)}`,
    requestData,
    options,
  ) as Promise<PutUsersUserIDProfilePictureFetchResponse>;
};

export type PatchUsersSettingsFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchUsersSettingsPath = () => `/api/v1/users/settings`;

export const patchUsersSettings = (
  requestContract: UpdateUserSettingsRequest,
  options?: FetchArgsOptions,
): Promise<PatchUsersSettingsFetchResponse> => {
  const requestData = getApiRequestData<UpdateUserSettingsRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchUsersSettingsPath()}`,
    requestData,
    options,
  ) as Promise<PatchUsersSettingsFetchResponse>;
};

export type GetUserNotificationsFetchResponse =
  | FetchResponse<EntityListOfUserNotificationDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUserNotificationsPath = () => `/api/v1/user-notifications`;

export const getUserNotifications = (
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetUserNotificationsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getUserNotificationsPath()}`,
    options,
    queryParams,
  ) as Promise<GetUserNotificationsFetchResponse>;
};

export type GetUserNotificationsUnseenCountFetchResponse =
  | FetchResponse<UnseenNotificationCountDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUserNotificationsUnseenCountPath = () =>
  `/api/v1/user-notifications/unseen-count`;

export const getUserNotificationsUnseenCount = (
  options?: FetchArgsOptions,
): Promise<GetUserNotificationsUnseenCountFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getUserNotificationsUnseenCountPath()}`,
    options,
    {},
  ) as Promise<GetUserNotificationsUnseenCountFetchResponse>;
};

export type PutUserNotificationsSeenFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUserNotificationsSeenPath = () =>
  `/api/v1/user-notifications/seen`;

export const putUserNotificationsSeen = (
  options?: FetchArgsOptions,
): Promise<PutUserNotificationsSeenFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPut(
    `${getApiUrl()}${putUserNotificationsSeenPath()}`,
    requestData,
    options,
  ) as Promise<PutUserNotificationsSeenFetchResponse>;
};

export type PutUserNotificationsUserNotificationIDReadFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUserNotificationsUserNotificationIDReadPath = (
  userNotificationID: string,
) => `/api/v1/user-notifications/${userNotificationID}/read`;

export const putUserNotificationsUserNotificationIDRead = (
  userNotificationID: string,
  options?: FetchArgsOptions,
): Promise<PutUserNotificationsUserNotificationIDReadFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPut(
    `${getApiUrl()}${putUserNotificationsUserNotificationIDReadPath(userNotificationID)}`,
    requestData,
    options,
  ) as Promise<PutUserNotificationsUserNotificationIDReadFetchResponse>;
};

export type PutUserNotificationsReadAllFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUserNotificationsReadAllPath = () =>
  `/api/v1/user-notifications/read-all`;

export const putUserNotificationsReadAll = (
  options?: FetchArgsOptions,
): Promise<PutUserNotificationsReadAllFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPut(
    `${getApiUrl()}${putUserNotificationsReadAllPath()}`,
    requestData,
    options,
  ) as Promise<PutUserNotificationsReadAllFetchResponse>;
};

export type PutUserNotificationsUserNotificationIDDismissFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUserNotificationsUserNotificationIDDismissPath = (
  userNotificationID: string,
) => `/api/v1/user-notifications/${userNotificationID}/dismiss`;

export const putUserNotificationsUserNotificationIDDismiss = (
  userNotificationID: string,
  options?: FetchArgsOptions,
): Promise<PutUserNotificationsUserNotificationIDDismissFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPut(
    `${getApiUrl()}${putUserNotificationsUserNotificationIDDismissPath(userNotificationID)}`,
    requestData,
    options,
  ) as Promise<PutUserNotificationsUserNotificationIDDismissFetchResponse>;
};

export type PutUserNotificationsDismissAllFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putUserNotificationsDismissAllPath = () =>
  `/api/v1/user-notifications/dismiss-all`;

export const putUserNotificationsDismissAll = (
  options?: FetchArgsOptions,
): Promise<PutUserNotificationsDismissAllFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPut(
    `${getApiUrl()}${putUserNotificationsDismissAllPath()}`,
    requestData,
    options,
  ) as Promise<PutUserNotificationsDismissAllFetchResponse>;
};

export type GetReportingKpisFetchResponse =
  | FetchResponse<ReportingKpisDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingKpisPath = () => `/api/v1/reporting/kpis`;

export const getReportingKpis = (
  options?: FetchArgsOptions,
): Promise<GetReportingKpisFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getReportingKpisPath()}`,
    options,
    {},
  ) as Promise<GetReportingKpisFetchResponse>;
};

export type GetReportingFinanceFetchResponse =
  | FetchResponse<ReportingFinanceDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingFinancePath = () => `/api/v1/reporting/finance`;

export const getReportingFinance = (
  options?: FetchArgsOptions,
): Promise<GetReportingFinanceFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getReportingFinancePath()}`,
    options,
    {},
  ) as Promise<GetReportingFinanceFetchResponse>;
};

export type GetReportingProjectsFetchResponse =
  | FetchResponse<ReportingProjectsDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingProjectsPath = () => `/api/v1/reporting/projects`;

export const getReportingProjects = (
  options?: FetchArgsOptions,
): Promise<GetReportingProjectsFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getReportingProjectsPath()}`,
    options,
    {},
  ) as Promise<GetReportingProjectsFetchResponse>;
};

export type GetReportingActorsFetchResponse =
  | FetchResponse<ReportingActorsDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingActorsPath = () => `/api/v1/reporting/actors`;

export const getReportingActors = (
  period?: ReportingPeriod | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetReportingActorsFetchResponse> => {
  const queryParams = {
    period: period,
  };
  return apiGet(
    `${getApiUrl()}${getReportingActorsPath()}`,
    options,
    queryParams,
  ) as Promise<GetReportingActorsFetchResponse>;
};

export type GetReportingPartnersFetchResponse =
  | FetchResponse<ReportingPartnersDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingPartnersPath = () => `/api/v1/reporting/partners`;

export const getReportingPartners = (
  period?: ReportingPeriod | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetReportingPartnersFetchResponse> => {
  const queryParams = {
    period: period,
  };
  return apiGet(
    `${getApiUrl()}${getReportingPartnersPath()}`,
    options,
    queryParams,
  ) as Promise<GetReportingPartnersFetchResponse>;
};

export type GetReportingGenerationsFetchResponse =
  | FetchResponse<ReportingGenerationsDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getReportingGenerationsPath = () =>
  `/api/v1/reporting/generations`;

export const getReportingGenerations = (
  options?: FetchArgsOptions,
): Promise<GetReportingGenerationsFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getReportingGenerationsPath()}`,
    options,
    {},
  ) as Promise<GetReportingGenerationsFetchResponse>;
};

export type GetRegistrationRequestsFetchResponse =
  | FetchResponse<EntityListOfRegistrationRequestListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getRegistrationRequestsPath = () =>
  `/api/v1/registration-requests`;

export const getRegistrationRequests = (
  offset?: number,
  limit?: number,
  status?: RegistrationRequestStatus | undefined | null,
  type?: RegistrationRequestType | undefined | null,
  searchQuery?: string | undefined | null,
  orderBy?: RegistrationRequestListOrderBy,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetRegistrationRequestsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    status: status,
    type: type,
    searchQuery: searchQuery,
    orderBy: orderBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getRegistrationRequestsPath()}`,
    options,
    queryParams,
  ) as Promise<GetRegistrationRequestsFetchResponse>;
};

export type GetRegistrationRequestsRegistrationRequestIDFetchResponse =
  | FetchResponse<RegistrationRequestDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getRegistrationRequestsRegistrationRequestIDPath = (
  registrationRequestID: string,
) => `/api/v1/registration-requests/${registrationRequestID}`;

export const getRegistrationRequestsRegistrationRequestID = (
  registrationRequestID: string,
  options?: FetchArgsOptions,
): Promise<GetRegistrationRequestsRegistrationRequestIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getRegistrationRequestsRegistrationRequestIDPath(registrationRequestID)}`,
    options,
    {},
  ) as Promise<GetRegistrationRequestsRegistrationRequestIDFetchResponse>;
};

export type PostRegistrationRequestsRegistrationRequestIDResolveFetchResponse =
  | FetchResponse<ResolveRegistrationRequestCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfResolveRegistrationRequestErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfResolveRegistrationRequestErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postRegistrationRequestsRegistrationRequestIDResolvePath = (
  registrationRequestID: string,
) => `/api/v1/registration-requests/${registrationRequestID}/resolve`;

export const postRegistrationRequestsRegistrationRequestIDResolve = (
  registrationRequestID: string,
  options?: FetchArgsOptions,
): Promise<PostRegistrationRequestsRegistrationRequestIDResolveFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postRegistrationRequestsRegistrationRequestIDResolvePath(registrationRequestID)}`,
    requestData,
    options,
  ) as Promise<PostRegistrationRequestsRegistrationRequestIDResolveFetchResponse>;
};

export type GetProjectsProjectIDDocumentsFetchResponse =
  | FetchResponse<EntityListOfDocumentListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsProjectIDDocumentsPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/documents`;

export const getProjectsProjectIDDocuments = (
  projectID: string,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetProjectsProjectIDDocumentsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getProjectsProjectIDDocumentsPath(projectID)}`,
    options,
    queryParams,
  ) as Promise<GetProjectsProjectIDDocumentsFetchResponse>;
};

export type PostProjectsProjectIDDocumentsFetchResponse =
  | FetchResponse<UploadProjectDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsProjectIDDocumentsPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/documents`;

export const postProjectsProjectIDDocuments = (
  requestContract: DocumentUploadRequest,
  projectID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDDocumentsFetchResponse> => {
  const requestData = getApiRequestData<DocumentUploadRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDDocumentsPath(projectID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDDocumentsFetchResponse>;
};

export type DeleteProjectsProjectIDDocumentsProjectDocumentIDFetchResponse =
  | FetchResponse<DeleteProjectDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteProjectsProjectIDDocumentsProjectDocumentIDPath = (
  projectID: string,
  projectDocumentID: string,
) => `/api/v1/projects/${projectID}/documents/${projectDocumentID}`;

export const deleteProjectsProjectIDDocumentsProjectDocumentID = (
  projectID: string,
  projectDocumentID: string,
  options?: FetchArgsOptions,
): Promise<DeleteProjectsProjectIDDocumentsProjectDocumentIDFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deleteProjectsProjectIDDocumentsProjectDocumentIDPath(projectID, projectDocumentID)}`,
    options,
    {},
  ) as Promise<DeleteProjectsProjectIDDocumentsProjectDocumentIDFetchResponse>;
};

export type GetProjectsFetchResponse =
  | FetchResponse<EntityListOfProjectsListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsPath = () => `/api/v1/projects`;

export const getProjects = (
  offset?: number,
  limit?: number,
  clientID?: string | undefined | null,
  projectState?: ProjectState | undefined | null,
  searchQuery?: string | undefined | null,
  sortBy?: SortableColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetProjectsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    clientID: clientID,
    projectState: projectState,
    searchQuery: searchQuery,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getProjectsPath()}`,
    options,
    queryParams,
  ) as Promise<GetProjectsFetchResponse>;
};

export type PostProjectsFetchResponse =
  | FetchResponse<SaveProjectCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveProjectErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsPath = () => `/api/v1/projects`;

export const postProjects = (
  requestContract: SaveProjectRequest,
  options?: FetchArgsOptions,
): Promise<PostProjectsFetchResponse> => {
  const requestData = getApiRequestData<SaveProjectRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsPath()}`,
    requestData,
    options,
  ) as Promise<PostProjectsFetchResponse>;
};

export type GetProjectsProjectIDFetchResponse =
  | FetchResponse<ProjectDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsProjectIDPath = (projectID: string) =>
  `/api/v1/projects/${projectID}`;

export const getProjectsProjectID = (
  projectID: string,
  options?: FetchArgsOptions,
): Promise<GetProjectsProjectIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getProjectsProjectIDPath(projectID)}`,
    options,
    {},
  ) as Promise<GetProjectsProjectIDFetchResponse>;
};

export type PutProjectsProjectIDFetchResponse =
  | FetchResponse<SaveProjectCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveProjectErrorStatus, 403>
  | FetchResponse<ApiProblemDetailsOfSaveProjectErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putProjectsProjectIDPath = (projectID: string) =>
  `/api/v1/projects/${projectID}`;

export const putProjectsProjectID = (
  requestContract: SaveProjectRequest,
  projectID: string,
  options?: FetchArgsOptions,
): Promise<PutProjectsProjectIDFetchResponse> => {
  const requestData = getApiRequestData<SaveProjectRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putProjectsProjectIDPath(projectID)}`,
    requestData,
    options,
  ) as Promise<PutProjectsProjectIDFetchResponse>;
};

export type PostProjectsProjectIDActorsFetchResponse =
  | FetchResponse<SyncProjectActorsCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSyncProjectActorsErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSyncProjectActorsErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsProjectIDActorsPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/actors`;

export const postProjectsProjectIDActors = (
  requestContract: SyncProjectActorsRequest,
  projectID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDActorsFetchResponse> => {
  const requestData = getApiRequestData<SyncProjectActorsRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDActorsPath(projectID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDActorsFetchResponse>;
};

export type GetProjectsProjectIDActorVoicesFetchResponse =
  | FetchResponse<ProjectActorVoiceListItemDto[], 200>
  | FetchResponse<ProblemDetails, 401>
  | FetchResponse<ProblemDetails, 403>
  | FetchResponse<ProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsProjectIDActorVoicesPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/actor-voices`;

export const getProjectsProjectIDActorVoices = (
  projectID: string,
  options?: FetchArgsOptions,
): Promise<GetProjectsProjectIDActorVoicesFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getProjectsProjectIDActorVoicesPath(projectID)}`,
    options,
    {},
  ) as Promise<GetProjectsProjectIDActorVoicesFetchResponse>;
};

export type PatchProjectsProjectIDStateFetchResponse =
  | FetchResponse<void, 204>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchProjectsProjectIDStatePath = (projectID: string) =>
  `/api/v1/projects/${projectID}/state`;

export const patchProjectsProjectIDState = (
  requestContract: ProjectState,
  projectID: string,
  options?: FetchArgsOptions,
): Promise<PatchProjectsProjectIDStateFetchResponse> => {
  const requestData = getApiRequestData<ProjectState>(requestContract, false);

  return apiPatch(
    `${getApiUrl()}${patchProjectsProjectIDStatePath(projectID)}`,
    requestData,
    options,
  ) as Promise<PatchProjectsProjectIDStateFetchResponse>;
};

export type GetPricesCategoriesFetchResponse =
  | FetchResponse<EntityListOfPriceCategoryListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPricesCategoriesPath = () => `/api/v1/prices/categories`;

export const getPricesCategories = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  sortBy?: PriceCategoryListSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetPricesCategoriesFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getPricesCategoriesPath()}`,
    options,
    queryParams,
  ) as Promise<GetPricesCategoriesFetchResponse>;
};

export type PostPricesCategoriesFetchResponse =
  | FetchResponse<SavePriceCategoryCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSavePriceCategoryErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSavePriceCategoryErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postPricesCategoriesPath = () => `/api/v1/prices/categories`;

export const postPricesCategories = (
  requestContract: SavePriceCategoryRequest,
  options?: FetchArgsOptions,
): Promise<PostPricesCategoriesFetchResponse> => {
  const requestData = getApiRequestData<SavePriceCategoryRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postPricesCategoriesPath()}`,
    requestData,
    options,
  ) as Promise<PostPricesCategoriesFetchResponse>;
};

export type PutPricesCategoriesPriceCategoryIDFetchResponse =
  | FetchResponse<SavePriceCategoryCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSavePriceCategoryErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSavePriceCategoryErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfSavePriceCategoryErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putPricesCategoriesPriceCategoryIDPath = (
  priceCategoryID: string,
) => `/api/v1/prices/categories/${priceCategoryID}`;

export const putPricesCategoriesPriceCategoryID = (
  requestContract: SavePriceCategoryRequest,
  priceCategoryID: string,
  options?: FetchArgsOptions,
): Promise<PutPricesCategoriesPriceCategoryIDFetchResponse> => {
  const requestData = getApiRequestData<SavePriceCategoryRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putPricesCategoriesPriceCategoryIDPath(priceCategoryID)}`,
    requestData,
    options,
  ) as Promise<PutPricesCategoriesPriceCategoryIDFetchResponse>;
};

export type PatchPricesCategoriesPriceCategoryIDStatusFetchResponse =
  | FetchResponse<UpdatePriceCategoryStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchPricesCategoriesPriceCategoryIDStatusPath = (
  priceCategoryID: string,
) => `/api/v1/prices/categories/${priceCategoryID}/status`;

export const patchPricesCategoriesPriceCategoryIDStatus = (
  requestContract: UpdatePriceCategoryStatusRequest,
  priceCategoryID: string,
  options?: FetchArgsOptions,
): Promise<PatchPricesCategoriesPriceCategoryIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdatePriceCategoryStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchPricesCategoriesPriceCategoryIDStatusPath(priceCategoryID)}`,
    requestData,
    options,
  ) as Promise<PatchPricesCategoriesPriceCategoryIDStatusFetchResponse>;
};

export type GetPartnersPartnerIDDocumentsFetchResponse =
  | FetchResponse<EntityListOfDocumentListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnersPartnerIDDocumentsPath = (partnerID: string) =>
  `/api/v1/partners/${partnerID}/documents`;

export const getPartnersPartnerIDDocuments = (
  partnerID: string,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetPartnersPartnerIDDocumentsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getPartnersPartnerIDDocumentsPath(partnerID)}`,
    options,
    queryParams,
  ) as Promise<GetPartnersPartnerIDDocumentsFetchResponse>;
};

export type PostPartnersPartnerIDDocumentsFetchResponse =
  | FetchResponse<UploadPartnerDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postPartnersPartnerIDDocumentsPath = (partnerID: string) =>
  `/api/v1/partners/${partnerID}/documents`;

export const postPartnersPartnerIDDocuments = (
  requestContract: DocumentUploadRequest,
  partnerID: string,
  options?: FetchArgsOptions,
): Promise<PostPartnersPartnerIDDocumentsFetchResponse> => {
  const requestData = getApiRequestData<DocumentUploadRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postPartnersPartnerIDDocumentsPath(partnerID)}`,
    requestData,
    options,
  ) as Promise<PostPartnersPartnerIDDocumentsFetchResponse>;
};

export type DeletePartnersPartnerIDDocumentsPartnerDocumentIDFetchResponse =
  | FetchResponse<DeletePartnerDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deletePartnersPartnerIDDocumentsPartnerDocumentIDPath = (
  partnerID: string,
  partnerDocumentID: string,
) => `/api/v1/partners/${partnerID}/documents/${partnerDocumentID}`;

export const deletePartnersPartnerIDDocumentsPartnerDocumentID = (
  partnerID: string,
  partnerDocumentID: string,
  options?: FetchArgsOptions,
): Promise<DeletePartnersPartnerIDDocumentsPartnerDocumentIDFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deletePartnersPartnerIDDocumentsPartnerDocumentIDPath(partnerID, partnerDocumentID)}`,
    options,
    {},
  ) as Promise<DeletePartnersPartnerIDDocumentsPartnerDocumentIDFetchResponse>;
};

export type GetPartnersMediaFilesFetchResponse =
  | FetchResponse<EntityListOfPartnerMediaFileListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnersMediaFilesPath = () => `/api/v1/partners/media-files`;

export const getPartnersMediaFiles = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  sortBy?: PartnerMediaFileSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetPartnersMediaFilesFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getPartnersMediaFilesPath()}`,
    options,
    queryParams,
  ) as Promise<GetPartnersMediaFilesFetchResponse>;
};

export type PostPartnersMediaFilesFetchResponse =
  | FetchResponse<CreatePartnerMediaFileCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfCreatePartnerMediaFileErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfCreatePartnerMediaFileErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postPartnersMediaFilesPath = () => `/api/v1/partners/media-files`;

export const postPartnersMediaFiles = (
  requestContract: CreatePartnerMediaFileRequest,
  options?: FetchArgsOptions,
): Promise<PostPartnersMediaFilesFetchResponse> => {
  const requestData = getApiRequestData<CreatePartnerMediaFileRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postPartnersMediaFilesPath()}`,
    requestData,
    options,
  ) as Promise<PostPartnersMediaFilesFetchResponse>;
};

export type DeletePartnersMediaFilesPartnerMediaFileIdFetchResponse =
  | FetchResponse<DeletePartnerMediaFileCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deletePartnersMediaFilesPartnerMediaFileIdPath = (
  partnerMediaFileId: string,
) => `/api/v1/partners/media-files/${partnerMediaFileId}`;

export const deletePartnersMediaFilesPartnerMediaFileId = (
  partnerMediaFileId: string,
  options?: FetchArgsOptions,
): Promise<DeletePartnersMediaFilesPartnerMediaFileIdFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deletePartnersMediaFilesPartnerMediaFileIdPath(partnerMediaFileId)}`,
    options,
    {},
  ) as Promise<DeletePartnersMediaFilesPartnerMediaFileIdFetchResponse>;
};

export type PostPartnerModulesPartnerIDModuleIDToggleFetchResponse =
  | FetchResponse<TogglePartnerModuleCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfTogglePartnerModuleErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfTogglePartnerModuleErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postPartnerModulesPartnerIDModuleIDTogglePath = (
  partnerID: string,
  moduleID: string,
) => `/api/v1/partner-modules/${partnerID}/${moduleID}/toggle`;

export const postPartnerModulesPartnerIDModuleIDToggle = (
  requestContract: TogglePartnerModuleRequest,
  partnerID: string,
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<PostPartnerModulesPartnerIDModuleIDToggleFetchResponse> => {
  const requestData = getApiRequestData<TogglePartnerModuleRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postPartnerModulesPartnerIDModuleIDTogglePath(partnerID, moduleID)}`,
    requestData,
    options,
  ) as Promise<PostPartnerModulesPartnerIDModuleIDToggleFetchResponse>;
};

export type GetPartnerModulesPartnerIDFetchResponse =
  | FetchResponse<EntityListOfModuleWithPartnerStatusListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnerModulesPartnerIDPath = (partnerID: string) =>
  `/api/v1/partner-modules/${partnerID}`;

export const getPartnerModulesPartnerID = (
  partnerID: string,
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  onlyEnabled?: boolean | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetPartnerModulesPartnerIDFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    onlyEnabled: onlyEnabled,
  };
  return apiGet(
    `${getApiUrl()}${getPartnerModulesPartnerIDPath(partnerID)}`,
    options,
    queryParams,
  ) as Promise<GetPartnerModulesPartnerIDFetchResponse>;
};

export type PutPartnerModulesPartnerIDFetchResponse =
  | FetchResponse<SetPartnerModulesCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSetPartnerModulesErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putPartnerModulesPartnerIDPath = (partnerID: string) =>
  `/api/v1/partner-modules/${partnerID}`;

export const putPartnerModulesPartnerID = (
  requestContract: SetPartnerModulesRequest,
  partnerID: string,
  options?: FetchArgsOptions,
): Promise<PutPartnerModulesPartnerIDFetchResponse> => {
  const requestData = getApiRequestData<SetPartnerModulesRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putPartnerModulesPartnerIDPath(partnerID)}`,
    requestData,
    options,
  ) as Promise<PutPartnerModulesPartnerIDFetchResponse>;
};

export type GetPartnerModulesModuleModuleIDFetchResponse =
  | FetchResponse<EntityListOfPartnerWithModuleStatusListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnerModulesModuleModuleIDPath = (moduleID: string) =>
  `/api/v1/partner-modules/module/${moduleID}`;

export const getPartnerModulesModuleModuleID = (
  moduleID: string,
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  onlyEnabled?: boolean | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetPartnerModulesModuleModuleIDFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    onlyEnabled: onlyEnabled,
  };
  return apiGet(
    `${getApiUrl()}${getPartnerModulesModuleModuleIDPath(moduleID)}`,
    options,
    queryParams,
  ) as Promise<GetPartnerModulesModuleModuleIDFetchResponse>;
};

export type PutPartnerModulesModuleModuleIDFetchResponse =
  | FetchResponse<SetModulePartnersCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSetModulePartnersErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putPartnerModulesModuleModuleIDPath = (moduleID: string) =>
  `/api/v1/partner-modules/module/${moduleID}`;

export const putPartnerModulesModuleModuleID = (
  requestContract: SetModulePartnersRequest,
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<PutPartnerModulesModuleModuleIDFetchResponse> => {
  const requestData = getApiRequestData<SetModulePartnersRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putPartnerModulesModuleModuleIDPath(moduleID)}`,
    requestData,
    options,
  ) as Promise<PutPartnerModulesModuleModuleIDFetchResponse>;
};

export type GetPartnerModulesEnabledFetchResponse =
  | FetchResponse<EntityListOfEnabledModuleListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnerModulesEnabledPath = () =>
  `/api/v1/partner-modules/enabled`;

export const getPartnerModulesEnabled = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetPartnerModulesEnabledFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
  };
  return apiGet(
    `${getApiUrl()}${getPartnerModulesEnabledPath()}`,
    options,
    queryParams,
  ) as Promise<GetPartnerModulesEnabledFetchResponse>;
};

export type GetPartnersFetchResponse =
  | FetchResponse<EntityListOfPartnerListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 403>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnersPath = () => `/api/v1/partners`;

export const getPartners = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  sortBy?: PartnerListSortColumn,
  sortOrder?: SortOrder,
  statusFilter?: PartnerStatus[] | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetPartnersFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    sortBy: sortBy,
    sortOrder: sortOrder,
    statusFilter: statusFilter,
  };
  return apiGet(
    `${getApiUrl()}${getPartnersPath()}`,
    options,
    queryParams,
  ) as Promise<GetPartnersFetchResponse>;
};

export type PostPartnersFetchResponse =
  | FetchResponse<SavePartnerCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSavePartnerErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSavePartnerErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postPartnersPath = () => `/api/v1/partners`;

export const postPartners = (
  requestContract: SavePartnerRequest,
  options?: FetchArgsOptions,
): Promise<PostPartnersFetchResponse> => {
  const requestData = getApiRequestData<SavePartnerRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postPartnersPath()}`,
    requestData,
    options,
  ) as Promise<PostPartnersFetchResponse>;
};

export type GetPartnersSupervisorSearchFetchResponse =
  | FetchResponse<EntityListOfPartnerSupervisorSearchListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 403>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnersSupervisorSearchPath = () =>
  `/api/v1/partners/supervisor-search`;

export const getPartnersSupervisorSearch = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetPartnersSupervisorSearchFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
  };
  return apiGet(
    `${getApiUrl()}${getPartnersSupervisorSearchPath()}`,
    options,
    queryParams,
  ) as Promise<GetPartnersSupervisorSearchFetchResponse>;
};

export type GetPartnersPartnerIDFetchResponse =
  | FetchResponse<PartnerDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getPartnersPartnerIDPath = (partnerID: string) =>
  `/api/v1/partners/${partnerID}`;

export const getPartnersPartnerID = (
  partnerID: string,
  options?: FetchArgsOptions,
): Promise<GetPartnersPartnerIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getPartnersPartnerIDPath(partnerID)}`,
    options,
    {},
  ) as Promise<GetPartnersPartnerIDFetchResponse>;
};

export type PutPartnersPartnerIDFetchResponse =
  | FetchResponse<SavePartnerCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSavePartnerErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSavePartnerErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putPartnersPartnerIDPath = (partnerID: string) =>
  `/api/v1/partners/${partnerID}`;

export const putPartnersPartnerID = (
  requestContract: SavePartnerRequest,
  partnerID: string,
  options?: FetchArgsOptions,
): Promise<PutPartnersPartnerIDFetchResponse> => {
  const requestData = getApiRequestData<SavePartnerRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putPartnersPartnerIDPath(partnerID)}`,
    requestData,
    options,
  ) as Promise<PutPartnersPartnerIDFetchResponse>;
};

export type PatchPartnersPartnerIDStatusFetchResponse =
  | FetchResponse<UpdatePartnerStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfUpdatePartnerStatusErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchPartnersPartnerIDStatusPath = (partnerID: string) =>
  `/api/v1/partners/${partnerID}/status`;

export const patchPartnersPartnerIDStatus = (
  requestContract: UpdatePartnerStatusRequest,
  partnerID: string,
  options?: FetchArgsOptions,
): Promise<PatchPartnersPartnerIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdatePartnerStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchPartnersPartnerIDStatusPath(partnerID)}`,
    requestData,
    options,
  ) as Promise<PatchPartnersPartnerIDStatusFetchResponse>;
};

export type GetModulesFetchResponse =
  | FetchResponse<EntityListOfModuleListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getModulesPath = () => `/api/v1/modules`;

export const getModules = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  statusFilter?: ModuleStatus[] | undefined | null,
  sortBy?: ModuleListSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetModulesFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    statusFilter: statusFilter,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getModulesPath()}`,
    options,
    queryParams,
  ) as Promise<GetModulesFetchResponse>;
};

export type PostModulesFetchResponse =
  | FetchResponse<SaveModuleCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveModuleErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postModulesPath = () => `/api/v1/modules`;

export const postModules = (
  requestContract: SaveModuleRequest,
  options?: FetchArgsOptions,
): Promise<PostModulesFetchResponse> => {
  const requestData = getApiRequestData<SaveModuleRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postModulesPath()}`,
    requestData,
    options,
  ) as Promise<PostModulesFetchResponse>;
};

export type GetModulesModuleIDFetchResponse =
  | FetchResponse<ModuleDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getModulesModuleIDPath = (moduleID: string) =>
  `/api/v1/modules/${moduleID}`;

export const getModulesModuleID = (
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<GetModulesModuleIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getModulesModuleIDPath(moduleID)}`,
    options,
    {},
  ) as Promise<GetModulesModuleIDFetchResponse>;
};

export type PutModulesModuleIDFetchResponse =
  | FetchResponse<SaveModuleCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveModuleErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putModulesModuleIDPath = (moduleID: string) =>
  `/api/v1/modules/${moduleID}`;

export const putModulesModuleID = (
  requestContract: SaveModuleRequest,
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<PutModulesModuleIDFetchResponse> => {
  const requestData = getApiRequestData<SaveModuleRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putModulesModuleIDPath(moduleID)}`,
    requestData,
    options,
  ) as Promise<PutModulesModuleIDFetchResponse>;
};

export type PatchModulesModuleIDStatusFetchResponse =
  | FetchResponse<void, 204>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchModulesModuleIDStatusPath = (moduleID: string) =>
  `/api/v1/modules/${moduleID}/status`;

export const patchModulesModuleIDStatus = (
  requestContract: ModuleStatus,
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<PatchModulesModuleIDStatusFetchResponse> => {
  const requestData = getApiRequestData<ModuleStatus>(requestContract, false);

  return apiPatch(
    `${getApiUrl()}${patchModulesModuleIDStatusPath(moduleID)}`,
    requestData,
    options,
  ) as Promise<PatchModulesModuleIDStatusFetchResponse>;
};

export type GetModulesModuleIDQuestionsFetchResponse =
  | FetchResponse<ModuleQuestionDto[], 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getModulesModuleIDQuestionsPath = (moduleID: string) =>
  `/api/v1/modules/${moduleID}/questions`;

export const getModulesModuleIDQuestions = (
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<GetModulesModuleIDQuestionsFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getModulesModuleIDQuestionsPath(moduleID)}`,
    options,
    {},
  ) as Promise<GetModulesModuleIDQuestionsFetchResponse>;
};

export type PutModulesModuleIDQuestionsFetchResponse =
  | FetchResponse<SaveModuleQuestionsCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveModuleQuestionsErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveModuleQuestionsErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putModulesModuleIDQuestionsPath = (moduleID: string) =>
  `/api/v1/modules/${moduleID}/questions`;

export const putModulesModuleIDQuestions = (
  requestContract: SaveModuleQuestionsRequest,
  moduleID: string,
  options?: FetchArgsOptions,
): Promise<PutModulesModuleIDQuestionsFetchResponse> => {
  const requestData = getApiRequestData<SaveModuleQuestionsRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putModulesModuleIDQuestionsPath(moduleID)}`,
    requestData,
    options,
  ) as Promise<PutModulesModuleIDQuestionsFetchResponse>;
};

export type GetProjectsProjectIDJobsFetchResponse =
  | FetchResponse<EntityListOfJobListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsProjectIDJobsPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/jobs`;

export const getProjectsProjectIDJobs = (
  projectID: string,
  limit?: number,
  offset?: number,
  options?: FetchArgsOptions,
): Promise<GetProjectsProjectIDJobsFetchResponse> => {
  const queryParams = {
    limit: limit,
    offset: offset,
  };
  return apiGet(
    `${getApiUrl()}${getProjectsProjectIDJobsPath(projectID)}`,
    options,
    queryParams,
  ) as Promise<GetProjectsProjectIDJobsFetchResponse>;
};

export type PostProjectsProjectIDJobsFetchResponse =
  | FetchResponse<CreateJobCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfCreateJobErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsProjectIDJobsPath = (projectID: string) =>
  `/api/v1/projects/${projectID}/jobs`;

export const postProjectsProjectIDJobs = (
  requestContract: CreateJobRequest,
  projectID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDJobsFetchResponse> => {
  const requestData = getApiRequestData<CreateJobRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDJobsPath(projectID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDJobsFetchResponse>;
};

export type GetProjectsProjectIDJobsJobIDFetchResponse =
  | FetchResponse<JobDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getProjectsProjectIDJobsJobIDPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}`;

export const getProjectsProjectIDJobsJobID = (
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<GetProjectsProjectIDJobsJobIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getProjectsProjectIDJobsJobIDPath(projectID, jobID)}`,
    options,
    {},
  ) as Promise<GetProjectsProjectIDJobsJobIDFetchResponse>;
};

export type PutProjectsProjectIDJobsJobIDScriptFetchResponse =
  | FetchResponse<SaveJobScriptCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveJobScriptErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveJobScriptErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putProjectsProjectIDJobsJobIDScriptPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/script`;

export const putProjectsProjectIDJobsJobIDScript = (
  requestContract: JobScript,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PutProjectsProjectIDJobsJobIDScriptFetchResponse> => {
  const requestData = getApiRequestData<JobScript>(requestContract, false);

  return apiPut(
    `${getApiUrl()}${putProjectsProjectIDJobsJobIDScriptPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PutProjectsProjectIDJobsJobIDScriptFetchResponse>;
};

export type PutProjectsProjectIDJobsJobIDAnswersFetchResponse =
  | FetchResponse<SaveJobAnswersCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveJobAnswersErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveJobAnswersErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putProjectsProjectIDJobsJobIDAnswersPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/answers`;

export const putProjectsProjectIDJobsJobIDAnswers = (
  requestContract: SaveJobAnswersRequest,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PutProjectsProjectIDJobsJobIDAnswersFetchResponse> => {
  const requestData = getApiRequestData<SaveJobAnswersRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putProjectsProjectIDJobsJobIDAnswersPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PutProjectsProjectIDJobsJobIDAnswersFetchResponse>;
};

export type PostProjectsProjectIDJobsJobIDGenerateVoicelinesFetchResponse =
  | FetchResponse<GenerateVoicelinesCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfGenerateVoicelinesErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfGenerateVoicelinesErrorStatus, 429>
  | FetchResponse<ApiProblemDetailsOfGenerateVoicelinesErrorStatus, 500>
  | ErrorResponse;

export const postProjectsProjectIDJobsJobIDGenerateVoicelinesPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/generate-voicelines`;

export const postProjectsProjectIDJobsJobIDGenerateVoicelines = (
  requestContract: GenerateVoicelinesRequest,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDJobsJobIDGenerateVoicelinesFetchResponse> => {
  const requestData = getApiRequestData<GenerateVoicelinesRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDJobsJobIDGenerateVoicelinesPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDJobsJobIDGenerateVoicelinesFetchResponse>;
};

export type PostProjectsProjectIDJobsJobIDGenerateClipFetchResponse =
  | FetchResponse<GenerateJobClipCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfJobScriptValidationError, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfGenerateJobClipErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfGenerateJobClipErrorStatus, 500>
  | ErrorResponse;

export const postProjectsProjectIDJobsJobIDGenerateClipPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/generate-clip`;

export const postProjectsProjectIDJobsJobIDGenerateClip = (
  requestContract: GenerateJobClipRequest,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDJobsJobIDGenerateClipFetchResponse> => {
  const requestData = getApiRequestData<GenerateJobClipRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDJobsJobIDGenerateClipPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDJobsJobIDGenerateClipFetchResponse>;
};

export type PostProjectsProjectIDJobsJobIDRetryFinalizationFetchResponse =
  | FetchResponse<RetryFinalizationCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfRetryFinalizationErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfRetryFinalizationErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfRetryFinalizationErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsProjectIDJobsJobIDRetryFinalizationPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/retry-finalization`;

export const postProjectsProjectIDJobsJobIDRetryFinalization = (
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDJobsJobIDRetryFinalizationFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDJobsJobIDRetryFinalizationPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDJobsJobIDRetryFinalizationFetchResponse>;
};

export type PatchProjectsProjectIDJobsJobIDStatusFetchResponse =
  | FetchResponse<UpdateJobStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchProjectsProjectIDJobsJobIDStatusPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/status`;

export const patchProjectsProjectIDJobsJobIDStatus = (
  requestContract: UpdateJobStatusRequest,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PatchProjectsProjectIDJobsJobIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdateJobStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchProjectsProjectIDJobsJobIDStatusPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PatchProjectsProjectIDJobsJobIDStatusFetchResponse>;
};

export type PostProjectsProjectIDJobsJobIDSubmitFetchResponse =
  | FetchResponse<SubmitJobCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSubmitJobErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSubmitJobErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfSubmitJobErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postProjectsProjectIDJobsJobIDSubmitPath = (
  projectID: string,
  jobID: string,
) => `/api/v1/projects/${projectID}/jobs/${jobID}/submit`;

export const postProjectsProjectIDJobsJobIDSubmit = (
  requestContract: SubmitJobRequest,
  projectID: string,
  jobID: string,
  options?: FetchArgsOptions,
): Promise<PostProjectsProjectIDJobsJobIDSubmitFetchResponse> => {
  const requestData = getApiRequestData<SubmitJobRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postProjectsProjectIDJobsJobIDSubmitPath(projectID, jobID)}`,
    requestData,
    options,
  ) as Promise<PostProjectsProjectIDJobsJobIDSubmitFetchResponse>;
};

export type GetExchangeRatesFetchResponse =
  | FetchResponse<ExchangeRateDto[], 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getExchangeRatesPath = () => `/api/v1/exchange-rates`;

export const getExchangeRates = (
  options?: FetchArgsOptions,
): Promise<GetExchangeRatesFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getExchangeRatesPath()}`,
    options,
    {},
  ) as Promise<GetExchangeRatesFetchResponse>;
};

export type PostFilesFetchResponse =
  | FetchResponse<UploadFileCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfUploadFileCommandResultError, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postFilesPath = () => `/api/v1/files`;

export const postFiles = (
  requestContract: UploadFileRequest,
  options?: FetchArgsOptions,
): Promise<PostFilesFetchResponse> => {
  const requestData = getApiRequestData<UploadFileRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postFilesPath()}`,
    requestData,
    options,
  ) as Promise<PostFilesFetchResponse>;
};

export type GetFilesFileIDDownloadUrlFetchResponse =
  | FetchResponse<GetFileDownloadUrlQueryResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfGetFileDownloadUrlErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getFilesFileIDDownloadUrlPath = (fileID: string) =>
  `/api/v1/files/${fileID}/download-url`;

export const getFilesFileIDDownloadUrl = (
  fileID: string,
  options?: FetchArgsOptions,
): Promise<GetFilesFileIDDownloadUrlFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getFilesFileIDDownloadUrlPath(fileID)}`,
    options,
    {},
  ) as Promise<GetFilesFileIDDownloadUrlFetchResponse>;
};

export type GetClientsClientIDDocumentsFetchResponse =
  | FetchResponse<EntityListOfDocumentListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getClientsClientIDDocumentsPath = (clientID: string) =>
  `/api/v1/clients/${clientID}/documents`;

export const getClientsClientIDDocuments = (
  clientID: string,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetClientsClientIDDocumentsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getClientsClientIDDocumentsPath(clientID)}`,
    options,
    queryParams,
  ) as Promise<GetClientsClientIDDocumentsFetchResponse>;
};

export type PostClientsClientIDDocumentsFetchResponse =
  | FetchResponse<UploadClientDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postClientsClientIDDocumentsPath = (clientID: string) =>
  `/api/v1/clients/${clientID}/documents`;

export const postClientsClientIDDocuments = (
  requestContract: DocumentUploadRequest,
  clientID: string,
  options?: FetchArgsOptions,
): Promise<PostClientsClientIDDocumentsFetchResponse> => {
  const requestData = getApiRequestData<DocumentUploadRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postClientsClientIDDocumentsPath(clientID)}`,
    requestData,
    options,
  ) as Promise<PostClientsClientIDDocumentsFetchResponse>;
};

export type DeleteClientsClientIDDocumentsClientDocumentIDFetchResponse =
  | FetchResponse<DeleteClientDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteClientsClientIDDocumentsClientDocumentIDPath = (
  clientID: string,
  clientDocumentID: string,
) => `/api/v1/clients/${clientID}/documents/${clientDocumentID}`;

export const deleteClientsClientIDDocumentsClientDocumentID = (
  clientID: string,
  clientDocumentID: string,
  options?: FetchArgsOptions,
): Promise<DeleteClientsClientIDDocumentsClientDocumentIDFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deleteClientsClientIDDocumentsClientDocumentIDPath(clientID, clientDocumentID)}`,
    options,
    {},
  ) as Promise<DeleteClientsClientIDDocumentsClientDocumentIDFetchResponse>;
};

export type GetClientsFetchResponse =
  | FetchResponse<EntityListOfClientListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getClientsPath = () => `/api/v1/clients`;

export const getClients = (
  limit?: number,
  offset?: number,
  searchQuery?: string | undefined | null,
  partnerIDs?: string[] | undefined | null,
  sortBy?: ClientListSortColumn,
  sortOrder?: SortOrder,
  statusFilter?: ClientStatus[] | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetClientsFetchResponse> => {
  const queryParams = {
    limit: limit,
    offset: offset,
    searchQuery: searchQuery,
    partnerIDs: partnerIDs,
    sortBy: sortBy,
    sortOrder: sortOrder,
    statusFilter: statusFilter,
  };
  return apiGet(
    `${getApiUrl()}${getClientsPath()}`,
    options,
    queryParams,
  ) as Promise<GetClientsFetchResponse>;
};

export type PostClientsFetchResponse =
  | FetchResponse<SaveClientCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveClientErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveClientErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postClientsPath = () => `/api/v1/clients`;

export const postClients = (
  requestContract: SaveClientRequest,
  options?: FetchArgsOptions,
): Promise<PostClientsFetchResponse> => {
  const requestData = getApiRequestData<SaveClientRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postClientsPath()}`,
    requestData,
    options,
  ) as Promise<PostClientsFetchResponse>;
};

export type GetClientsClientIDFetchResponse =
  | FetchResponse<ClientDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getClientsClientIDPath = (clientID: string) =>
  `/api/v1/clients/${clientID}`;

export const getClientsClientID = (
  clientID: string,
  options?: FetchArgsOptions,
): Promise<GetClientsClientIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getClientsClientIDPath(clientID)}`,
    options,
    {},
  ) as Promise<GetClientsClientIDFetchResponse>;
};

export type PutClientsClientIDFetchResponse =
  | FetchResponse<SaveClientCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveClientErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveClientErrorStatus, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putClientsClientIDPath = (clientID: string) =>
  `/api/v1/clients/${clientID}`;

export const putClientsClientID = (
  requestContract: SaveClientRequest,
  clientID: string,
  options?: FetchArgsOptions,
): Promise<PutClientsClientIDFetchResponse> => {
  const requestData = getApiRequestData<SaveClientRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putClientsClientIDPath(clientID)}`,
    requestData,
    options,
  ) as Promise<PutClientsClientIDFetchResponse>;
};

export type PatchClientsClientIDStatusFetchResponse =
  | FetchResponse<UpdateClientStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchClientsClientIDStatusPath = (clientID: string) =>
  `/api/v1/clients/${clientID}/status`;

export const patchClientsClientIDStatus = (
  requestContract: UpdateClientStatusRequest,
  clientID: string,
  options?: FetchArgsOptions,
): Promise<PatchClientsClientIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdateClientStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchClientsClientIDStatusPath(clientID)}`,
    requestData,
    options,
  ) as Promise<PatchClientsClientIDStatusFetchResponse>;
};

export type GetBillingBalanceFetchResponse =
  | FetchResponse<PartnerBalanceResult, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getBillingBalancePath = () => `/api/v1/billing/balance`;

export const getBillingBalance = (
  options?: FetchArgsOptions,
): Promise<GetBillingBalanceFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getBillingBalancePath()}`,
    options,
    {},
  ) as Promise<GetBillingBalanceFetchResponse>;
};

export type GetBillingTransactionsFetchResponse =
  | FetchResponse<EntityListOfTransactionListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getBillingTransactionsPath = () => `/api/v1/billing/transactions`;

export const getBillingTransactions = (
  offset?: number,
  limit?: number,
  transactionType?: TransactionType | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetBillingTransactionsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    transactionType: transactionType,
  };
  return apiGet(
    `${getApiUrl()}${getBillingTransactionsPath()}`,
    options,
    queryParams,
  ) as Promise<GetBillingTransactionsFetchResponse>;
};

export type PostBillingInitiateDepositFetchResponse =
  | FetchResponse<InitiateDepositCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfInitiateDepositErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postBillingInitiateDepositPath = () =>
  `/api/v1/billing/initiate-deposit`;

export const postBillingInitiateDeposit = (
  requestContract: InitiateDepositRequest,
  options?: FetchArgsOptions,
): Promise<PostBillingInitiateDepositFetchResponse> => {
  const requestData = getApiRequestData<InitiateDepositRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postBillingInitiateDepositPath()}`,
    requestData,
    options,
  ) as Promise<PostBillingInitiateDepositFetchResponse>;
};

export type GetInvoicesFetchResponse =
  | FetchResponse<EntityListOfInvoiceListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getInvoicesPath = () => `/api/v1/invoices`;

export const getInvoices = (
  offset?: number,
  limit?: number,
  invoiceType?: InvoiceType | undefined | null,
  search?: string | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetInvoicesFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    invoiceType: invoiceType,
    search: search,
  };
  return apiGet(
    `${getApiUrl()}${getInvoicesPath()}`,
    options,
    queryParams,
  ) as Promise<GetInvoicesFetchResponse>;
};

export type GetInvoicesPartnerFetchResponse =
  | FetchResponse<EntityListOfInvoiceListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getInvoicesPartnerPath = () => `/api/v1/invoices/partner`;

export const getInvoicesPartner = (
  offset?: number,
  limit?: number,
  invoiceType?: InvoiceType | undefined | null,
  search?: string | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetInvoicesPartnerFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    invoiceType: invoiceType,
    search: search,
  };
  return apiGet(
    `${getApiUrl()}${getInvoicesPartnerPath()}`,
    options,
    queryParams,
  ) as Promise<GetInvoicesPartnerFetchResponse>;
};

export type GetInvoicesInvoiceIDPdfFetchResponse =
  | FetchResponse<void, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getInvoicesInvoiceIDPdfPath = (invoiceID: string) =>
  `/api/v1/invoices/${invoiceID}/pdf`;

export const getInvoicesInvoiceIDPdf = (
  invoiceID: string,
  options?: FetchArgsOptions,
): Promise<GetInvoicesInvoiceIDPdfFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getInvoicesInvoiceIDPdfPath(invoiceID)}`,
    options,
    {},
  ) as Promise<GetInvoicesInvoiceIDPdfFetchResponse>;
};

export type GetWithdrawalApprovalFetchResponse =
  | FetchResponse<EntityListOfWithdrawalListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getWithdrawalApprovalPath = () => `/api/v1/withdrawal-approval`;

export const getWithdrawalApproval = (
  offset?: number,
  limit?: number,
  status?: WithdrawalRequestStatus | undefined | null,
  searchQuery?: string | undefined | null,
  orderBy?: WithdrawalListOrderBy,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetWithdrawalApprovalFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    status: status,
    searchQuery: searchQuery,
    orderBy: orderBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getWithdrawalApprovalPath()}`,
    options,
    queryParams,
  ) as Promise<GetWithdrawalApprovalFetchResponse>;
};

export type GetWithdrawalApprovalWithdrawalRequestIDFetchResponse =
  | FetchResponse<WithdrawalApprovalDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getWithdrawalApprovalWithdrawalRequestIDPath = (
  withdrawalRequestID: string,
) => `/api/v1/withdrawal-approval/${withdrawalRequestID}`;

export const getWithdrawalApprovalWithdrawalRequestID = (
  withdrawalRequestID: string,
  options?: FetchArgsOptions,
): Promise<GetWithdrawalApprovalWithdrawalRequestIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getWithdrawalApprovalWithdrawalRequestIDPath(withdrawalRequestID)}`,
    options,
    {},
  ) as Promise<GetWithdrawalApprovalWithdrawalRequestIDFetchResponse>;
};

export type PostWithdrawalApprovalWithdrawalRequestIDApproveFetchResponse =
  | FetchResponse<ApproveWithdrawalCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfApproveWithdrawalErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfApproveWithdrawalErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfApproveWithdrawalErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postWithdrawalApprovalWithdrawalRequestIDApprovePath = (
  withdrawalRequestID: string,
) => `/api/v1/withdrawal-approval/${withdrawalRequestID}/approve`;

export const postWithdrawalApprovalWithdrawalRequestIDApprove = (
  withdrawalRequestID: string,
  options?: FetchArgsOptions,
): Promise<PostWithdrawalApprovalWithdrawalRequestIDApproveFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postWithdrawalApprovalWithdrawalRequestIDApprovePath(withdrawalRequestID)}`,
    requestData,
    options,
  ) as Promise<PostWithdrawalApprovalWithdrawalRequestIDApproveFetchResponse>;
};

export type PostWithdrawalApprovalWithdrawalRequestIDRejectFetchResponse =
  | FetchResponse<RejectWithdrawalCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfRejectWithdrawalErrorStatus, 404>
  | FetchResponse<ApiProblemDetailsOfRejectWithdrawalErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postWithdrawalApprovalWithdrawalRequestIDRejectPath = (
  withdrawalRequestID: string,
) => `/api/v1/withdrawal-approval/${withdrawalRequestID}/reject`;

export const postWithdrawalApprovalWithdrawalRequestIDReject = (
  requestContract: RejectWithdrawalRequest,
  withdrawalRequestID: string,
  options?: FetchArgsOptions,
): Promise<PostWithdrawalApprovalWithdrawalRequestIDRejectFetchResponse> => {
  const requestData = getApiRequestData<RejectWithdrawalRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postWithdrawalApprovalWithdrawalRequestIDRejectPath(withdrawalRequestID)}`,
    requestData,
    options,
  ) as Promise<PostWithdrawalApprovalWithdrawalRequestIDRejectFetchResponse>;
};

export type PostAuthRegisterPartnerFetchResponse =
  | FetchResponse<RegisterPartnerCommandResult, 201>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfRegisterPartnerErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthRegisterPartnerPath = () =>
  `/api/v1/auth/register-partner`;

export const postAuthRegisterPartner = (
  requestContract: RegisterPartnerRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthRegisterPartnerFetchResponse> => {
  const requestData = getApiRequestData<RegisterPartnerRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postAuthRegisterPartnerPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthRegisterPartnerFetchResponse>;
};

export type PostAuthRegisterActorFetchResponse =
  | FetchResponse<RegisterActorCommandResult, 201>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfRegisterActorErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthRegisterActorPath = () => `/api/v1/auth/register-actor`;

export const postAuthRegisterActor = (
  requestContract: RegisterActorRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthRegisterActorFetchResponse> => {
  const requestData = getApiRequestData<RegisterActorRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postAuthRegisterActorPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthRegisterActorFetchResponse>;
};

export type PostAuthSignInFetchResponse =
  | FetchResponse<SignInResult, 200>
  | FetchResponse<ApiProblemDetailsOfAuthError, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthSignInPath = () => `/api/v1/auth/sign-in`;

export const postAuthSignIn = (
  requestContract: SignInRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthSignInFetchResponse> => {
  const requestData = getApiRequestData<SignInRequest>(requestContract, false);

  return apiPost(
    `${getApiUrl()}${postAuthSignInPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthSignInFetchResponse>;
};

export type PostAuthSsoFetchResponse =
  | FetchResponse<SignInResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfAuthError, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthSsoPath = () => `/api/v1/auth/sso`;

export const postAuthSso = (
  requestContract: SsoSignInRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthSsoFetchResponse> => {
  const requestData = getApiRequestData<SsoSignInRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postAuthSsoPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthSsoFetchResponse>;
};

export type PostAuthPasswordResetFetchResponse =
  | FetchResponse<ResetPasswordCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfResetPasswordCommandResultStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthPasswordResetPath = () => `/api/v1/auth/password-reset`;

export const postAuthPasswordReset = (
  requestContract: ResetPasswordCommand,
  options?: FetchArgsOptions,
): Promise<PostAuthPasswordResetFetchResponse> => {
  const requestData = getApiRequestData<ResetPasswordCommand>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postAuthPasswordResetPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthPasswordResetFetchResponse>;
};

export type PutAuthPasswordFetchResponse =
  | FetchResponse<SetPasswordCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfPasswordChangeResultStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSetPasswordCommandStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putAuthPasswordPath = () => `/api/v1/auth/password`;

export const putAuthPassword = (
  requestContract: SetPasswordCommand,
  options?: FetchArgsOptions,
): Promise<PutAuthPasswordFetchResponse> => {
  const requestData = getApiRequestData<SetPasswordCommand>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putAuthPasswordPath()}`,
    requestData,
    options,
  ) as Promise<PutAuthPasswordFetchResponse>;
};

export type GetAuthSentryTestFetchResponse =
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getAuthSentryTestPath = () => `/api/v1/auth/sentry-test`;

export const getAuthSentryTest = (
  options?: FetchArgsOptions,
): Promise<GetAuthSentryTestFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getAuthSentryTestPath()}`,
    options,
    {},
  ) as Promise<GetAuthSentryTestFetchResponse>;
};

export type GetAuthUserinfoFetchResponse =
  | FetchResponse<UserInfo, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getAuthUserinfoPath = () => `/api/v1/auth/userinfo`;

export const getAuthUserinfo = (
  options?: FetchArgsOptions,
): Promise<GetAuthUserinfoFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getAuthUserinfoPath()}`,
    options,
    {},
  ) as Promise<GetAuthUserinfoFetchResponse>;
};

export type PostAuthRefreshTokenFetchResponse =
  | FetchResponse<SignInResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthRefreshTokenPath = () => `/api/v1/auth/refresh-token`;

export const postAuthRefreshToken = (
  options?: FetchArgsOptions,
): Promise<PostAuthRefreshTokenFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postAuthRefreshTokenPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthRefreshTokenFetchResponse>;
};

export type PostAudioWatermarkDetectFetchResponse =
  | FetchResponse<DetectAudioWatermarkCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfDetectAudioWatermarkErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAudioWatermarkDetectPath = () =>
  `/api/v1/audio/watermark/detect`;

export const postAudioWatermarkDetect = (
  requestContract: DetectAudioWatermarkRequest,
  options?: FetchArgsOptions,
): Promise<PostAudioWatermarkDetectFetchResponse> => {
  const requestData = getApiRequestData<DetectAudioWatermarkRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postAudioWatermarkDetectPath()}`,
    requestData,
    options,
  ) as Promise<PostAudioWatermarkDetectFetchResponse>;
};

export type GetActorsActorIDDocumentsFetchResponse =
  | FetchResponse<EntityListOfDocumentListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDDocumentsPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/documents`;

export const getActorsActorIDDocuments = (
  actorID: string,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDDocumentsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getActorsActorIDDocumentsPath(actorID)}`,
    options,
    queryParams,
  ) as Promise<GetActorsActorIDDocumentsFetchResponse>;
};

export type PostActorsActorIDDocumentsFetchResponse =
  | FetchResponse<UploadActorDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfDocumentUploadErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDDocumentsPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/documents`;

export const postActorsActorIDDocuments = (
  requestContract: DocumentUploadRequest,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDDocumentsFetchResponse> => {
  const requestData = getApiRequestData<DocumentUploadRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postActorsActorIDDocumentsPath(actorID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDDocumentsFetchResponse>;
};

export type DeleteActorsActorIDDocumentsActorDocumentIDFetchResponse =
  | FetchResponse<DeleteActorDocumentCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteActorsActorIDDocumentsActorDocumentIDPath = (
  actorID: string,
  actorDocumentID: string,
) => `/api/v1/actors/${actorID}/documents/${actorDocumentID}`;

export const deleteActorsActorIDDocumentsActorDocumentID = (
  actorID: string,
  actorDocumentID: string,
  options?: FetchArgsOptions,
): Promise<DeleteActorsActorIDDocumentsActorDocumentIDFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deleteActorsActorIDDocumentsActorDocumentIDPath(actorID, actorDocumentID)}`,
    options,
    {},
  ) as Promise<DeleteActorsActorIDDocumentsActorDocumentIDFetchResponse>;
};

export type GetActorsActorIDPriceCategoriesFetchResponse =
  | FetchResponse<ActorPriceCategoryListItemDto[], 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDPriceCategoriesPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/price-categories`;

export const getActorsActorIDPriceCategories = (
  actorID: string,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDPriceCategoriesFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getActorsActorIDPriceCategoriesPath(actorID)}`,
    options,
    {},
  ) as Promise<GetActorsActorIDPriceCategoriesFetchResponse>;
};

export type PostActorsActorIDPriceCategoriesFetchResponse =
  | FetchResponse<SaveActorPriceCategoriesCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetailsOfSaveActorPriceCategoriesErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDPriceCategoriesPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/price-categories`;

export const postActorsActorIDPriceCategories = (
  requestContract: SaveActorPriceCategoriesRequest,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDPriceCategoriesFetchResponse> => {
  const requestData = getApiRequestData<SaveActorPriceCategoriesRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postActorsActorIDPriceCategoriesPath(actorID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDPriceCategoriesFetchResponse>;
};

export type GetActorsActorIDPriceCategoriesHistoryFetchResponse =
  | FetchResponse<EntityListOfActorPriceCategoryListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDPriceCategoriesHistoryPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/price-categories/history`;

export const getActorsActorIDPriceCategoriesHistory = (
  actorID: string,
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDPriceCategoriesHistoryFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getActorsActorIDPriceCategoriesHistoryPath(actorID)}`,
    options,
    queryParams,
  ) as Promise<GetActorsActorIDPriceCategoriesHistoryFetchResponse>;
};

export type GetActorsFetchResponse =
  | FetchResponse<EntityListOfActorListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsPath = () => `/api/v1/actors`;

export const getActors = (
  offset?: number,
  limit?: number,
  searchQuery?: string | undefined | null,
  languages?: LanguageCodes[] | undefined | null,
  ages?: number[] | undefined | null,
  genders?: GenderType[] | undefined | null,
  priceCategoryID?: string,
  onlyOpenToCollaboration?: boolean | undefined | null,
  onlyWithActiveVoice?: boolean | undefined | null,
  excludeNotAllowed?: boolean,
  includeActorIDs?: string[] | undefined | null,
  voiceLlms?: VoiceLlm[] | undefined | null,
  industry?: Industry | undefined | null,
  statusFilter?: ActorStatus[] | undefined | null,
  orderBy?: ActorListOrderBy,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetActorsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    searchQuery: searchQuery,
    languages: languages,
    ages: ages,
    genders: genders,
    priceCategoryID: priceCategoryID,
    onlyOpenToCollaboration: onlyOpenToCollaboration,
    onlyWithActiveVoice: onlyWithActiveVoice,
    excludeNotAllowed: excludeNotAllowed,
    includeActorIDs: includeActorIDs,
    voiceLlms: voiceLlms,
    industry: industry,
    statusFilter: statusFilter,
    orderBy: orderBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getActorsPath()}`,
    options,
    queryParams,
  ) as Promise<GetActorsFetchResponse>;
};

export type PostActorsFetchResponse =
  | FetchResponse<SaveActorCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveActorErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveActorErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsPath = () => `/api/v1/actors`;

export const postActors = (
  requestContract: SaveActorRequest,
  options?: FetchArgsOptions,
): Promise<PostActorsFetchResponse> => {
  const requestData = getApiRequestData<SaveActorRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postActorsPath()}`,
    requestData,
    options,
  ) as Promise<PostActorsFetchResponse>;
};

export type GetActorsActorIDFetchResponse =
  | FetchResponse<ActorDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDPath = (actorID: string) =>
  `/api/v1/actors/${actorID}`;

export const getActorsActorID = (
  actorID: string,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getActorsActorIDPath(actorID)}`,
    options,
    {},
  ) as Promise<GetActorsActorIDFetchResponse>;
};

export type PutActorsActorIDFetchResponse =
  | FetchResponse<SaveActorCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveActorErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveActorErrorStatus, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putActorsActorIDPath = (actorID: string) =>
  `/api/v1/actors/${actorID}`;

export const putActorsActorID = (
  requestContract: SaveActorRequest,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<PutActorsActorIDFetchResponse> => {
  const requestData = getApiRequestData<SaveActorRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putActorsActorIDPath(actorID)}`,
    requestData,
    options,
  ) as Promise<PutActorsActorIDFetchResponse>;
};

export type PatchActorsActorIDStatusFetchResponse =
  | FetchResponse<UpdateActorStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchActorsActorIDStatusPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/status`;

export const patchActorsActorIDStatus = (
  requestContract: UpdateActorStatusRequest,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<PatchActorsActorIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdateActorStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchActorsActorIDStatusPath(actorID)}`,
    requestData,
    options,
  ) as Promise<PatchActorsActorIDStatusFetchResponse>;
};

export type GetActorsActorIDTransactionsFetchResponse =
  | FetchResponse<EntityListOfTransactionListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDTransactionsPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/transactions`;

export const getActorsActorIDTransactions = (
  actorID: string,
  offset?: number,
  limit?: number,
  transactionType?: TransactionType | undefined | null,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDTransactionsFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
    transactionType: transactionType,
  };
  return apiGet(
    `${getApiUrl()}${getActorsActorIDTransactionsPath(actorID)}`,
    options,
    queryParams,
  ) as Promise<GetActorsActorIDTransactionsFetchResponse>;
};

export type GetActorsActorIDActorVoicesFetchResponse =
  | FetchResponse<ActorVoiceListItemDto[], 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDActorVoicesPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/actor-voices`;

export const getActorsActorIDActorVoices = (
  actorID: string,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDActorVoicesFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getActorsActorIDActorVoicesPath(actorID)}`,
    options,
    {},
  ) as Promise<GetActorsActorIDActorVoicesFetchResponse>;
};

export type PostActorsActorIDActorVoicesFetchResponse =
  | FetchResponse<SaveActorVoiceCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveActorVoiceErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetailsOfSaveActorVoiceErrorStatus, 409>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDActorVoicesPath = (actorID: string) =>
  `/api/v1/actors/${actorID}/actor-voices`;

export const postActorsActorIDActorVoices = (
  requestContract: SaveActorVoiceRequest,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDActorVoicesFetchResponse> => {
  const requestData = getApiRequestData<SaveActorVoiceRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postActorsActorIDActorVoicesPath(actorID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDActorVoicesFetchResponse>;
};

export type GetActorsActorIDActorVoicesActorVoiceIDFetchResponse =
  | FetchResponse<ActorVoiceDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActorsActorIDActorVoicesActorVoiceIDPath = (
  actorVoiceID: string,
  actorID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}`;

export const getActorsActorIDActorVoicesActorVoiceID = (
  actorVoiceID: string,
  actorID: string,
  options?: FetchArgsOptions,
): Promise<GetActorsActorIDActorVoicesActorVoiceIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getActorsActorIDActorVoicesActorVoiceIDPath(actorVoiceID, actorID)}`,
    options,
    {},
  ) as Promise<GetActorsActorIDActorVoicesActorVoiceIDFetchResponse>;
};

export type PutActorsActorIDActorVoicesActorVoiceIDFetchResponse =
  | FetchResponse<SaveActorVoiceCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfSaveActorVoiceErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfSaveActorVoiceErrorStatus, 403>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const putActorsActorIDActorVoicesActorVoiceIDPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}`;

export const putActorsActorIDActorVoicesActorVoiceID = (
  requestContract: SaveActorVoiceRequest,
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<PutActorsActorIDActorVoicesActorVoiceIDFetchResponse> => {
  const requestData = getApiRequestData<SaveActorVoiceRequest>(
    requestContract,
    false,
  );

  return apiPut(
    `${getApiUrl()}${putActorsActorIDActorVoicesActorVoiceIDPath(actorID, actorVoiceID)}`,
    requestData,
    options,
  ) as Promise<PutActorsActorIDActorVoicesActorVoiceIDFetchResponse>;
};

export type DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse =
  | FetchResponse<DeleteAllActorVoiceTrainingFilesCommandResult, 200>
  | FetchResponse<
      ApiProblemDetailsOfDeleteAllActorVoiceTrainingFilesErrorStatus,
      400
    >
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<
      ApiProblemDetailsOfDeleteAllActorVoiceTrainingFilesErrorStatus,
      404
    >
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/training-files`;

export const deleteActorsActorIDActorVoicesActorVoiceIDTrainingFiles = (
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse> => {
  return apiDelete(
    `${getApiUrl()}${deleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesPath(actorID, actorVoiceID)}`,
    options,
    {},
  ) as Promise<DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse>;
};

export type PostActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse =
  | FetchResponse<UploadActorVoiceTrainingFileCommandResult, 200>
  | FetchResponse<
      ApiProblemDetailsOfUploadActorVoiceTrainingFileErrorStatus,
      400
    >
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<
      ApiProblemDetailsOfUploadActorVoiceTrainingFileErrorStatus,
      404
    >
  | FetchResponse<
      ApiProblemDetailsOfUploadActorVoiceTrainingFileErrorStatus,
      409
    >
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDActorVoicesActorVoiceIDTrainingFilesPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/training-files`;

export const postActorsActorIDActorVoicesActorVoiceIDTrainingFiles = (
  requestContract: UploadActorVoiceTrainingFileRequest,
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse> => {
  const requestData = getApiRequestData<UploadActorVoiceTrainingFileRequest>(
    requestContract,
    true,
  );

  return apiPost(
    `${getApiUrl()}${postActorsActorIDActorVoicesActorVoiceIDTrainingFilesPath(actorID, actorVoiceID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDActorVoicesActorVoiceIDTrainingFilesFetchResponse>;
};

export type DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileIDFetchResponse =
  | FetchResponse<DeleteActorVoiceTrainingFileCommandResult, 200>
  | FetchResponse<
      ApiProblemDetailsOfDeleteActorVoiceTrainingFileErrorStatus,
      400
    >
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<
      ApiProblemDetailsOfDeleteActorVoiceTrainingFileErrorStatus,
      404
    >
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const deleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileIDPath =
  (actorID: string, actorVoiceTrainingFileID: string, actorVoiceID: string) =>
    `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/training-files/${actorVoiceTrainingFileID}`;

export const deleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileID =
  (
    actorID: string,
    actorVoiceTrainingFileID: string,
    actorVoiceID: string,
    options?: FetchArgsOptions,
  ): Promise<DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileIDFetchResponse> => {
    return apiDelete(
      `${getApiUrl()}${deleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileIDPath(actorID, actorVoiceTrainingFileID, actorVoiceID)}`,
      options,
      {},
    ) as Promise<DeleteActorsActorIDActorVoicesActorVoiceIDTrainingFilesActorVoiceTrainingFileIDFetchResponse>;
  };

export type PostActorsActorIDActorVoicesActorVoiceIDGeneratePreviewFetchResponse =
  | FetchResponse<GenerateActorVoicePreviewCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfGenerateActorVoicePreviewErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetailsOfGenerateActorVoicePreviewErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDActorVoicesActorVoiceIDGeneratePreviewPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/generate-preview`;

export const postActorsActorIDActorVoicesActorVoiceIDGeneratePreview = (
  requestContract: GenerateActorVoicePreviewRequest,
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDActorVoicesActorVoiceIDGeneratePreviewFetchResponse> => {
  const requestData = getApiRequestData<GenerateActorVoicePreviewRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postActorsActorIDActorVoicesActorVoiceIDGeneratePreviewPath(actorID, actorVoiceID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDActorVoicesActorVoiceIDGeneratePreviewFetchResponse>;
};

export type PatchActorsActorIDActorVoicesActorVoiceIDStatusFetchResponse =
  | FetchResponse<UpdateActorVoiceStatusCommandResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const patchActorsActorIDActorVoicesActorVoiceIDStatusPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/status`;

export const patchActorsActorIDActorVoicesActorVoiceIDStatus = (
  requestContract: UpdateActorVoiceStatusRequest,
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<PatchActorsActorIDActorVoicesActorVoiceIDStatusFetchResponse> => {
  const requestData = getApiRequestData<UpdateActorVoiceStatusRequest>(
    requestContract,
    false,
  );

  return apiPatch(
    `${getApiUrl()}${patchActorsActorIDActorVoicesActorVoiceIDStatusPath(actorID, actorVoiceID)}`,
    requestData,
    options,
  ) as Promise<PatchActorsActorIDActorVoicesActorVoiceIDStatusFetchResponse>;
};

export type PostActorsActorIDActorVoicesActorVoiceIDStartTrainingFetchResponse =
  | FetchResponse<UploadActorVoiceTrainingFileCommandResult, 200>
  | FetchResponse<ApiProblemDetailsOfTrainingActorVoiceErrorStatus, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetails, 403>
  | FetchResponse<ApiProblemDetailsOfTrainingActorVoiceErrorStatus, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postActorsActorIDActorVoicesActorVoiceIDStartTrainingPath = (
  actorID: string,
  actorVoiceID: string,
) => `/api/v1/actors/${actorID}/actor-voices/${actorVoiceID}/start-training`;

export const postActorsActorIDActorVoicesActorVoiceIDStartTraining = (
  actorID: string,
  actorVoiceID: string,
  options?: FetchArgsOptions,
): Promise<PostActorsActorIDActorVoicesActorVoiceIDStartTrainingFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postActorsActorIDActorVoicesActorVoiceIDStartTrainingPath(actorID, actorVoiceID)}`,
    requestData,
    options,
  ) as Promise<PostActorsActorIDActorVoicesActorVoiceIDStartTrainingFetchResponse>;
};

export type GetActivityLogFetchResponse =
  | FetchResponse<EntityListOfActivityLogListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getActivityLogPath = () => `/api/v1/activity-log`;

export const getActivityLog = (
  limit?: number,
  offset?: number,
  activityEventType?: ActivityEventType | undefined | null,
  dateFrom?: string | undefined | null,
  dateTo?: string | undefined | null,
  sortBy?: ActivityLogSortColumn,
  sortOrder?: SortOrder,
  options?: FetchArgsOptions,
): Promise<GetActivityLogFetchResponse> => {
  const queryParams = {
    limit: limit,
    offset: offset,
    activityEventType: activityEventType,
    dateFrom: dateFrom,
    dateTo: dateTo,
    sortBy: sortBy,
    sortOrder: sortOrder,
  };
  return apiGet(
    `${getApiUrl()}${getActivityLogPath()}`,
    options,
    queryParams,
  ) as Promise<GetActivityLogFetchResponse>;
};
